


const getPrideployApi = function(){
    const ua = navigator.userAgent.toLowerCase();
    let bool = ua.includes('electron/') && !ua.includes('wxwork');
    if(bool){
      let apiStr = localStorage.getItem('prideployApi') || ''
      let resObj = {
        baseUrl:apiStr,
        websockUrl:apiStr.replace('http://','ws://').replace('https://','wss://'),
      }
      return resObj
    }
    return {baseUrl:null,websockUrl:null}
}
// const getPrideployApi = function(){
//     const ua = navigator.userAgent.toLowerCase();
//     let bool = ua.includes('electron/') && !ua.includes('wxwork');
//     if(bool){
//       let apiStr = localStorage.getItem('prideployApi') || ''
//       // 如果 apiStr 已经是 ws:// 开头，替换会失效
//       let wsUrl = apiStr
//       if(apiStr.startsWith('http://')){
//         wsUrl = apiStr.replace('http://','ws://')
//       } else if(apiStr.startsWith('https://')){
//         wsUrl = apiStr.replace('https://','wss://')
//       }
//       // 如果已经是 ws:// 或 wss://，保持不变
//       return {
//         baseUrl: apiStr,
//         websockUrl: wsUrl,
//       }
//     }
//     return {baseUrl: null, websockUrl: null}
// }
let prideployApi = getPrideployApi() || {}

let baseUrl = prideployApi.baseUrl || process.env.VUE_APP_API_BASE_URL
let websockUrl = prideployApi.websockUrl || process.env.VUE_APP_WS_BASEURL
let replaceStr = process.env.VUE_APP_API_STREAM_KEY

// IM HTTP 独立 base：未配置时回退到主 API base
let imBaseUrl = process.env.VUE_APP_IM_API_BASE_URL || baseUrl

if(process.env.VUE_APP_ENV == 'prideploy'){
    baseUrl = QSPRI_CONFIG.API_BASEURL
    websockUrl = QSPRI_CONFIG.WS_BASEURL
    replaceStr = QSPRI_CONFIG.STREAM_KEY

    // prideploy 下优先运行时配置 IM_API_BASEURL，否则回退 API_BASEURL
    imBaseUrl = QSPRI_CONFIG.IM_API_BASEURL || QSPRI_CONFIG.API_BASEURL || imBaseUrl
}
const joinBaseUrl = function (url) {
  return baseUrl + url;
}
const joinImBaseUrl = function(url){
  return imBaseUrl + url
}
const joinWebsockUrl = function (url) {
  return websockUrl + url
}
const joinStreamUrl = function (url) {
    let resUrl = baseUrl
    if(replaceStr){
        let keys = replaceStr.split(':')
        resUrl = resUrl.replace(keys[0],keys[1])
    }
  return resUrl + url
}
const api = {
  pub: {
    sendVerifyCode: joinBaseUrl('/pub/svr/sms/smsSend/sendVerifyCode'),
    regOrg: joinBaseUrl('/pub/org/user/pub/regOrg'),
    login: joinBaseUrl('/pub/org/user/pub/login'),
    websocket: joinWebsockUrl('/pub/im/websocket'),
    restPswd: joinBaseUrl('/pub/org/user/pub/restPswd'),
    isLogin: joinBaseUrl('/pub/session/isLogin'),
    inviteJoinOrg: joinBaseUrl('/pub/org/user/pub/inviteJoinOrg'),
    queryOrgNameByCode: joinBaseUrl('/pub/org/user/pub/queryOrgNameByCode'),
    // doPost: 'http://qs3test.keyunsoft.com/apiportal/pub/svr/file/manager/onlyofficeCallback/doPost',
    doPost: joinBaseUrl('/pub/svr/file/manager/onlyofficeCallback/doPost'),
    applyToBeExternalEmp: joinBaseUrl('/pub/org/user/pub/applyToBeExternalEmp'),
    externalEmpLogin: joinBaseUrl('/pub/org/user/pub/externalEmpLogin'),
    pubGrant: joinBaseUrl('/pub/upload/grant'),
    pubPrivateFile: joinBaseUrl('/pub/upload/privateFile'),
    pubPublicFile: joinBaseUrl('/pub/upload/publicFile'),
    pubFileUrl: joinBaseUrl('/pub/upload/fileUrl'),
	qywxLogin:{
        authCodeUrl:baseUrl+'/pub/integrate/qywx/qywxPub/authCodeUrl',
        qywxLogin:baseUrl+'/pub/integrate/qywx/qywxPub/qywxLogin',
	},
	qywxInstallLogin:{
        getAuthCodeUrl:baseUrl+'/pub/integrate/qywx/install/getAuthCodeUrl',
        installLogin:baseUrl+'/pub/integrate/qywx/install/installLogin',
	},
	ddInstallLogin:{
        authCodeLogin:baseUrl+'/pub/integrate/dingtalk/ddinstall/authCodeLogin',
	},
  },
  file: {
    startUpload: joinBaseUrl('/svr/largefile/manager/startUpload'),
    formalUpload: joinBaseUrl('/svr/largefile/manager/formalUpload'),
    recoverUpload: joinBaseUrl('/svr/largefile/manager/recoverUpload'),
    cancelUpload: joinBaseUrl('/svr/largefile/manager/cancelUpload'),
    uploadPrivateFile: joinBaseUrl('/svr/file/manager/file/uploadPrivateFile'),
},
  bpa:{
    addBizFlow: joinBaseUrl('/bpa/bizFlow/bizFlow/addBizFlow'),
    queryBizFlowTree: joinBaseUrl('/bpa/bizFlow/bizFlow/queryBizFlowTree'),
    editBizFlow: joinBaseUrl('/bpa/bizFlow/bizFlow/editBizFlow'),
    delBizFlow: joinBaseUrl('/bpa/bizFlow/bizFlow/delBizFlow'),
    queryBizFlowDtl: joinBaseUrl('/bpa/bizFlow/bizFlow/queryBizFlowDtl'),
    adjustBizFlowSeq: joinBaseUrl('/bpa/bizFlow/bizFlow/adjustBizFlowSeq'),

    queryBfVerList: joinBaseUrl('/bpa/bizFlow/bfVer/queryBfVerList'),
    copyBfVer: joinBaseUrl('/bpa/bizFlow/bfVer/copyBfVer'),
    startUpBfVer: joinBaseUrl('/bpa/bizFlow/bfVer/startUpBfVer'),
    delBfVer: joinBaseUrl('/bpa/bizFlow/bfVer/delBfVer'),
    queryBfVerDtl: joinBaseUrl('/bpa/bizFlow/bfVer/queryBfVerDtl'),
    editBfVer: joinBaseUrl('/bpa/bizFlow/bfVer/editBfVer'),
    queryAllBfKeyEles: joinBaseUrl('/bpa/bizFlow/bfKeyEle/queryAllBfKeyEles'),

    addBfRgime: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfRgime/addBfRgime'),
    editBfRgime: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfRgime/editBfRgime'),
    delBfRgime: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfRgime/delBfRgime'),
    
    addBfSop: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfSop/addBfSop'),
    editBfSop: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfSop/editBfSop'),
    delBfSop: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfSop/delBfSop'),
    
    addBfSoft: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfSoft/addBfSoft'),
    editBfSoft: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfSoft/editBfSoft'),
    delBfSoft: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfSoft/delBfSoft'),
    
    addBfKn: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfKn/addBfKn'),
    editBfKn: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfKn/editBfKn'),
    delBfKn: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfKn/delBfKn'),
    
    addBfFile: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFile/addBfFile'),
    editBfFile: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFile/editBfFile'),
    delBfFile: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFile/delBfFile'),

    editBfStructGraph: joinBaseUrl('/bpa/bizFlow/bfStructGraph/editBfStructGraph'),
    queryBfStructGraphDtl: joinBaseUrl('/bpa/bizFlow/bfStructGraph/queryBfStructGraphDtl'),
    queryBfStructGraphDtlMgt: joinBaseUrl('/bpa/bizFlow/bfStructGraphConfig/queryBfStructGraphDtl'),


    addBfNode: joinBaseUrl('/bpa/bizFlow/bfNode/addBfNode'),
    editBfNode: joinBaseUrl('/bpa/bizFlow/bfNode/editBfNode'),
    delBfNode: joinBaseUrl('/bpa/bizFlow/bfNode/delBfNode'),
    queryBfNodeDtl: joinBaseUrl('/bpa/bizFlow/bfNode/queryBfNodeDtl'),
    queryBizFlowGraph: joinBaseUrl('/bpa/bizFlow/bfNode/queryBizFlowGraph'),
    queryBfSwimDtl: joinBaseUrl('/bpa/bizFlow/bfSwim/queryBfSwimDtl'),
    addBfNodeLine: joinBaseUrl('/bpa/bizFlow/bfNodeLine/addBfNodeLine'),
    editBfNodeLine: joinBaseUrl('/bpa/bizFlow/bfNodeLine/editBfNodeLine'),
    addBfSwim: joinBaseUrl('/bpa/bizFlow/bfSwim/addBfSwim'),
    delBfSwim: joinBaseUrl('/bpa/bizFlow/bfSwim/delBfSwim'),
    editBfSwim: joinBaseUrl('/bpa/bizFlow/bfSwim/editBfSwim'),
    queryBfSwimList: joinBaseUrl('/bpa/bizFlow/bfSwim/queryBfSwimList'),
    batchUpdateSwimSet: joinBaseUrl('/bpa/bizFlow/bfSwim/batchUpdateSwimSet'),
    queryBfvSwimSet: joinBaseUrl('/bpa/bizFlow/bfVer/queryBfvSwimSet'),
    editBfvSwimSet: joinBaseUrl('/bpa/bizFlow/bfVer/editBfvSwimSet'),
    delBfNodeLine: joinBaseUrl('/bpa/bizFlow/bfNodeLine/delBfNodeLine'),
    copyBfAndGraph: joinBaseUrl('/bpa/bizFlow/bizFlow/copyBfAndGraph'),
    queryBfNodeList: joinBaseUrl('/bpa/bizFlow/bfNode/queryBfNodeList'),

    queryBfFilePageGroupList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/queryBfFilePageGroupList'),
    addBfFilePageGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/addBfFilePageGroup'),
    editBfFilePageGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/editBfFilePageGroup'),
    delBfFilePageGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/delBfFilePageGroup'),
    queryBfFilePageList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/queryBfFilePageList'),
    addBfFilePage: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/addBfFilePage'),
    editBfFilePage: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/editBfFilePage'),
    delBfFilePage: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/delBfFilePage'),
    queryBfFilePageVerList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/queryBfFilePageVerList'),
    queryBfFilePageDtl: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/queryBfFilePageDtl'),
    copyBfFilePageVer: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/copyBfFilePageVer'),
    editBfFilePageVer: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/editBfFilePageVer'),
    upBfFilePageVer: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/upBfFilePageVer'),
    queryBvKeyFactorDtl: joinBaseUrl('/bpa/bizFlow/bvKeyFactor/queryBvKeyFactorDtl'),
    queryBfFilePageVerDtl: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/queryBfFilePageVerDtl'),
    editBvKeyFactor: joinBaseUrl('/bpa/bizFlow/bvKeyFactor/editBvKeyFactor'),
    addPostDuty: joinBaseUrl('/bpa/bizFlow/bfKeyEle/postDuty/addPostDuty'),
    editPostDuty: joinBaseUrl('/bpa/bizFlow/bfKeyEle/postDuty/editPostDuty'),
    queryPostDutyList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/postDuty/queryPostDutyList'),
    addBfAuth: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfAuth/addBfAuth'),
    editBfAuth: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfAuth/editBfAuth'),
    addBfIndex: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfIndex/addBfIndex'),
    editBfIndex: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfIndex/editBfIndex'),
    queryBfIndexGroupList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfIndex/queryBfIndexGroupList'),
    addBfIndexGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfIndex/addBfIndexGroup'),
    addBfRisk: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfRisk/addBfRisk'),
    editBfRisk: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfRisk/editBfRisk'),
    queryBfRiskGroupList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfRisk/queryBfRiskGroupList'),
    addBfRiskGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfRisk/addBfRiskGroup'),
    queryBfIndexList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfIndex/queryBfIndexList'),
    delBfIndexGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfIndex/delBfIndexGroup'),
    delBfIndex: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfIndex/delBfIndex'),
    editBfIndexGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfIndex/editBfIndexGroup'),
    queryPostBizFlowList: joinBaseUrl('/bpa/bizFlow/bizFlow/queryPostBizFlowList'),
    queryBfSoftList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfSoft/queryBfSoftList'),
    queryBfRiskList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfRisk/queryBfRiskList'),
    delPostDuty: joinBaseUrl('/bpa/bizFlow/bfKeyEle/postDuty/delPostDuty'),
    delBfAuth: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfAuth/delBfAuth'),
    delBfRisk: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfRisk/delBfRisk'),
    editBvRpsaci: joinBaseUrl('/bpa/bizFlow/bvRpsaci/editBvRpsaci'),
    queryBvRpsaciDtl: joinBaseUrl('/bpa/bizFlow/bvRpsaci/queryBvRpsaciDtl'),
    queryProjectByCond: joinBaseUrl('/bpa/bizFlow/project/queryProjectByCond'),
    queryKeyEleCount: joinBaseUrl('/bpa/bizFlow/project/queryKeyEleCount'),
    queryKeyEleByCond: joinBaseUrl('/bpa/bizFlow/project/queryKeyEleByCond'),
    queryBillboard: joinBaseUrl('/bpa/bizFlow/bfBillboard/queryBillboard'),
    addBvFileFactor: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/addBvFileFactor'),
    delBvFileFactor: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/delBvFileFactor'),
    addBvSoftFactor: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfSoft/addBvSoftFactor'),
    delBvSoftFactor: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfSoft/delBvSoftFactor'),
    queryBnByControlType: joinBaseUrl('/bpa/bizFlow/bfNode/queryBnByControlType'),
    queryFeedbackList: joinBaseUrl('/bpa/bizFlow/bfVer/feedback/queryFeedbackList'),
    addFeedback: joinBaseUrl('/bpa/bizFlow/bfVer/feedback/addFeedback'),
    editFeedback: joinBaseUrl('/bpa/bizFlow/bfVer/feedback/editFeedback'),
    delFeedback: joinBaseUrl('/bpa/bizFlow/bfVer/feedback/delFeedback'),
    queryMyPostsBfList: joinBaseUrl('/bpa/bizFlow/bizFlow/queryMyPostsBfList'),
    printBizFlowTree: joinBaseUrl('/bpa/bpaPrint/printBizFlowTree'),
    queryBfListByPostId: joinBaseUrl('/bpa/bizFlow/project/queryBfListByPostId'),
    queryPostDutyByPostId: joinBaseUrl('/bpa/bizFlow/project/queryPostDutyByPostId'),
    queryBfAuthGroupList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfAuth/queryBfAuthGroupList'),
    queryBfAuthList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfAuth/queryBfAuthList'),
    queryPostDutyByBfId: joinBaseUrl('/bpa/bizFlow/bizFlow/queryPostDutyByBfId'),
    adjustBfFilePageGroupSeq: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/adjustBfFilePageGroupSeq'),
    queryBfExaTaskList: joinBaseUrl('/bpa/bizFlow/bfExaTask/queryBfExaTaskList'),
    addBfExaTask: joinBaseUrl('/bpa/bizFlow/bfExaTask/addBfExaTask'),
    dealBfExaTask: joinBaseUrl('/bpa/bizFlow/bfExaTask/dealBfExaTask'),
    adjustBfRiskGroupSeq: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfRisk/adjustBfRiskGroupSeq'),
    adjustBfIndexGroupSeq: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfIndex/adjustBfIndexGroupSeq'),
    adjustBfAuthGroupSeq: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfAuth/adjustBfAuthGroupSeq'),
    addBfAuthGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfAuth/addBfAuthGroup'),
    editBfAuthGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfAuth/editBfAuthGroup'),
    delBfAuthGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfAuth/delBfAuthGroup'),
    addBsgNode: joinBaseUrl('/bpa/bizFlow/bfStructGraph/bsgNode/addBsgNode'),
    editBsgNode: joinBaseUrl('/bpa/bizFlow/bfStructGraph/bsgNode/editBsgNode'),
    delBsgNode: joinBaseUrl('/bpa/bizFlow/bfStructGraph/bsgNode/delBsgNode'),
    queryBfStructGraph: joinBaseUrl('/bpa/bizFlow/bfStructGraph/bsgNode/queryBfStructGraph'),
    addBfSoftGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfSoft/addBfSoftGroup'),
    editBfSoftGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfSoft/editBfSoftGroup'),
    delBfSoftGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfSoft/delBfSoftGroup'),
    queryBfSoftGroupList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfSoft/queryBfSoftGroupList'),
    adjustBfSoftGroupSeq: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfSoft/adjustBfSoftGroupSeq'),
    queryBfListByKey: joinBaseUrl('/bpa/bizFlow/bizFlow/queryBfListByKey'),
    queryBfListByDepId: joinBaseUrl('/bpa/bizFlow/depAndPostBf/queryBfListByDepId'),
    postQueryBfListByPostId: joinBaseUrl('/bpa/bizFlow/depAndPostBf/queryBfListByPostId'),
    queryKeyEleCountByPostId: joinBaseUrl('/bpa/bizFlow/depAndPostBf/queryKeyEleCountByPostId'),
    queryKeyEleCountByDepId: joinBaseUrl('/bpa/bizFlow/depAndPostBf/queryKeyEleCountByDepId'),
    queryKeyEleListByPostId: joinBaseUrl('/bpa/bizFlow/depAndPostBf/queryKeyEleListByPostId'),
    queryKeyEleListByDepId: joinBaseUrl('/bpa/bizFlow/depAndPostBf/queryKeyEleListByDepId'),
    addBfAndFactor: joinBaseUrl('/bpa/bizFlow/bfAndFactor/addBfAndFactor'),
    delBfAndFactor: joinBaseUrl('/bpa/bizFlow/bfAndFactor/delBfAndFactor'),
    queryBfAndFactorList: joinBaseUrl('/bpa/bizFlow/bfAndFactor/queryBfAndFactorList'),
    copyBfStructGraph: joinBaseUrl('/bpa/bizFlow/bfStructGraph/bsgNode/copyBfStructGraph'),
    delBfRiskGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfRisk/delBfRiskGroup'),
    addBsgNodeLine: joinBaseUrl('/bpa/bizFlow/bfStructGraph/bsgNodeLine/addBsgNodeLine'),
    editBsgNodeLine: joinBaseUrl('/bpa/bizFlow/bfStructGraph/bsgNodeLine/editBsgNodeLine'),
    delBsgNodeLine: joinBaseUrl('/bpa/bizFlow/bfStructGraph/bsgNodeLine/delBsgNodeLine'),
    addBvAndFactor: joinBaseUrl('/bpa/bizFlow/bnAndFactor/addBnAndFactor'),
    delBvAndFactor: joinBaseUrl('/bpa/bizFlow/bnAndFactor/delBnAndFactor'),
    queryFirstLevel: joinBaseUrl('/bpa/bizFlow/bizFlow/queryFirstLevel'),
    queryBizFlowTreeByType: joinBaseUrl('/bpa/bizFlow/bizFlow/queryBizFlowTreeByType'),
    queryBizFlowTreeByGroup: joinBaseUrl('/bpa/bizFlow/bizFlow/queryBizFlowTreeByGroup'),
    queryBsgNodeDtl: joinBaseUrl('/bpa/bizFlow/bfStructGraph/bsgNode/queryBsgNodeDtl'),

    addBfGroup: joinBaseUrl('/bpa/bizFlow/bpaAuth/addBfGroup'),
    editBfGroup: joinBaseUrl('/bpa/bizFlow/bpaAuth/editBfGroup'),
    delBfGroup: joinBaseUrl('/bpa/bizFlow/bpaAuth/delBfGroup'),
    queryBfGroupList: joinBaseUrl('/bpa/bizFlow/bpaAuth/queryBfGroupList'),
    queryAllGroupBizFlowTree: joinBaseUrl('/bpa/bizFlow/bizFlow/queryAllGroupBizFlowTree'),

    addBfRole: joinBaseUrl('/bpa/bizFlow/bpaAuth/addBfRole'),
    editBfRole: joinBaseUrl('/bpa/bizFlow/bpaAuth/editBfRole'),
    delBfRole: joinBaseUrl('/bpa/bizFlow/bpaAuth/delBfRole'),
    queryBfRoleList: joinBaseUrl('/bpa/bizFlow/bpaAuth/queryBfRoleList'),

    addBfRoleMem: joinBaseUrl('/bpa/bizFlow/bpaAuth/addBfRoleMem'),
    delBfRoleMem: joinBaseUrl('/bpa/bizFlow/bpaAuth/delBfRoleMem'),
    queryBfRoleMemList: joinBaseUrl('/bpa/bizFlow/bpaAuth/queryBfRoleMemList'),
    queryBsgNodeListByType: joinBaseUrl('/bpa/bizFlow/bfStructGraph/bsgNode/queryBsgNodeListByType'),
    queryBsgNodeListByIds: joinBaseUrl('/bpa/bizFlow/bfStructGraph/bsgNode/queryBsgNodeListByIds'),
    queryBfpTreeByIds: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/queryBfpTreeByIds'),
    editBfFilePageContent: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/editBfFilePageContent'),

    queryPostDutyByPostNodeId: joinBaseUrl('/bpa/bizFlow/project/queryPostDutyByPostNodeId'),
    queryPostDutyCountByPostNodeId: joinBaseUrl('/bpa/bizFlow/project/queryPostDutyCountByPostNodeId'),
    queryCurUserPostNodeList: joinBaseUrl('/bpa/bizFlow/project/queryCurUserPostNodeList'),
    queryPostProject: joinBaseUrl('/bpa/bizFlow/project/queryPostProject'),
    queryPostProjectEleCount: joinBaseUrl('/bpa/bizFlow/project/queryPostProjectEleCount'),
    queryPostProjectEleNodeList: joinBaseUrl('/bpa/bizFlow/project/queryPostProjectEleNodeList'),
    moveBvAttache: joinBaseUrl('/bpa/bizFlow/bfVer/moveBvAttache'),
  },
  newBpa:{
    // 制度
    queryBfInstitutionGroupTree: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfInstitution/queryBfInstitutionGroupTree'),
    addBfInstitutionGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfInstitution/addBfInstitutionGroup'),
    updateBfInstitutionGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfInstitution/updateBfInstitutionGroup'),
    delBfInstitutionGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfInstitution/delBfInstitutionGroup'),
    queryBfInstitutionList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfInstitution/queryBfInstitutionList'),
    addBfInstitution: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfInstitution/addBfInstitution'),
    delBfInstitution: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfInstitution/delBfInstitution'),
    updateBfInstitution: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfInstitution/updateBfInstitution'),
    queryBfInstitutionDtl: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfInstitution/queryBfInstitutionDtl'),
    // 文件
    queryBfFilePageGroupList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/queryBfFilePageGroupList'),
    addBfFilePageGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/addBfFilePageGroup'),
    editBfFilePageGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/editBfFilePageGroup'),
    delBfFilePageGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/delBfFilePageGroup'),
    queryBfFilePageList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/queryBfFilePageList'),
    addBfFilePage: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/addBfFilePage'),
    delBfFilePage: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/delBfFilePage'),
    editBfFilePage: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/editBfFilePage'),
    queryBfFilePageDtl: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfFilePage/queryBfFilePageDtl'),
    // 风险
    queryBfRiskGroupList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfRisk/queryBfRiskGroupList'),
    addBfRiskGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfRisk/addBfRiskGroup'),
    editBfRiskGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfRisk/editBfRiskGroup'),
    delBfRiskGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfRisk/delBfRiskGroup'),
    queryBfRiskList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfRisk/queryBfRiskList'),
    addBfRisk: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfRisk/addBfRisk'),
    delBfRisk: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfRisk/delBfRisk'),
    editBfRisk: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfRisk/editBfRisk'),
    queryBfRiskDtl: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfRisk/queryBfRiskDtl'),
    // 绩效
    queryBfIndexGroupList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfIndex/queryBfIndexGroupList'),
    addBfIndexGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfIndex/addBfIndexGroup'),
    editBfIndexGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfIndex/editBfIndexGroup'),
    delBfIndexGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfIndex/delBfIndexGroup'),
    queryBfIndexList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfIndex/queryBfIndexList'),
    addBfIndex: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfIndex/addBfIndex'),
    delBfIndex: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfIndex/delBfIndex'),
    editBfIndex: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfIndex/editBfIndex'),
    queryBfIndexDtl: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfIndex/queryBfIndexDtl'),
    // 授权
    queryBfAuthGroupList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfAuth/queryBfAuthGroupList'),
    addBfAuthGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfAuth/addBfAuthGroup'),
    editBfAuthGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfAuth/editBfAuthGroup'),
    delBfAuthGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfAuth/delBfAuthGroup'),
    queryBfAuthList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfAuth/queryBfAuthList'),
    addBfAuth: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfAuth/addBfAuth'),
    editBfAuth: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfAuth/editBfAuth'),
    delBfAuth: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfAuth/delBfAuth'),
    queryBfAuthDtl: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfAuth/queryBfAuthDtl'),
    // 能力
    queryBfCapaSysGroupTree: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfCapaSys/queryBfCapaSysGroupTree'),
    addBfCapaSysGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfCapaSys/addBfCapaSysGroup'),
    updateBfCapaSysGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfCapaSys/updateBfCapaSysGroup'),
    delBfCapaSysGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfCapaSys/delBfCapaSysGroup'),
    queryBfCapaSysList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfCapaSys/queryBfCapaSysList'),
    addBfCapaSys: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfCapaSys/addBfCapaSys'),
    updateBfCapaSys: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfCapaSys/updateBfCapaSys'),
    delBfCapaSys: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfCapaSys/delBfCapaSys'),
    queryBfCapaSysDtl: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfCapaSys/queryBfCapaSysDtl'),
    // 能力类型
    queryBfCapaSysTypeList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfCapaSys/queryBfCapaSysTypeList'),
    updateBfCapaSysType: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfCapaSys/updateBfCapaSysType'),
    delBfCapaSysType: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfCapaSys/delBfCapaSysType'),
    addBfCapaSysType: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfCapaSys/addBfCapaSysType'),
    // 名词术语
    queryBfNounTermGroupTree: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfNounTerm/queryBfNounTermGroupTree'),
    addBfNounTermGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfNounTerm/addBfNounTermGroup'),
    updateBfNounTermGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfNounTerm/updateBfNounTermGroup'),
    delBfNounTermGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfNounTerm/delBfNounTermGroup'),
    queryBfNounTermList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfNounTerm/queryBfNounTermList'),
    addBfNounTerm: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfNounTerm/addBfNounTerm'),
    updateBfNounTerm: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfNounTerm/updateBfNounTerm'),
    delBfNounTerm: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfNounTerm/delBfNounTerm'),
    queryBfNounTermDtl: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfNounTerm/queryBfNounTermDtl'),
    // It系统
    queryBfITSysGroupTree: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfITSys/queryBfITSysGroupTree'),
    addBfITSysGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfITSys/addBfITSysGroup'),
    updateBfITSysGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfITSys/updateBfITSysGroup'),
    delBfITSysGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfITSys/delBfITSysGroup'),
    queryBfITSysList: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfITSys/queryBfITSysList'),
    addBfITSys: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfITSys/addBfITSys'),
    updateBfITSys: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfITSys/updateBfITSys'),
    delBfITSys: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfITSys/delBfITSys'),
    queryBfITSysDtl: joinBaseUrl('/bpa/bizFlow/bfKeyEle/bfITSys/queryBfITSysDtl'),

    //流程分组
    queryBfBasicGroupList: joinBaseUrl('/bpa/bizFlow/bfBasicGroup/queryBfBasicGroupList'),
    addBfBasicGroup: joinBaseUrl('/bpa/bizFlow/bfBasicGroup/addBfBasicGroup'),
    updateBfBasicGroup: joinBaseUrl('/bpa/bizFlow/bfBasicGroup/updateBfBasicGroup'),
    delBfBasicGroup: joinBaseUrl('/bpa/bizFlow/bfBasicGroup/delBfBasicGroup'),
    adjustBfBasicGroupSeq: joinBaseUrl('/bpa/bizFlow/bfBasicGroup/adjustBfBasicGroupSeq'),

    //流程部门岗位
    queryBfDepTree: joinBaseUrl('/bpa/bpaOrg/bfDep/queryBfDepTree'),
    updateBfDep: joinBaseUrl('/bpa/bpaOrg/bfDep/updateBfDep'),
    addBfDep: joinBaseUrl('/bpa/bpaOrg/bfDep/addBfDep'),
    delBfDep: joinBaseUrl('/bpa/bpaOrg/bfDep/delBfDep'),
    queryBfPostList: joinBaseUrl('/bpa/bpaOrg/bfPost/queryBfPostList'),
    addBfPost: joinBaseUrl('/bpa/bpaOrg/bfPost/addBfPost'),
    delBfPost: joinBaseUrl('/bpa/bpaOrg/bfPost/delBfPost'),
    updateBfPost: joinBaseUrl('/bpa/bpaOrg/bfPost/updateBfPost'),

    // 流程要素选择器
    queryKeyEleGroupByType: joinBaseUrl('/bpa/bizFlow/bfKeyEle/queryKeyEleGroupByType'),
    queryKeyEleByTypeAndGroupId: joinBaseUrl('/bpa/bizFlow/bfKeyEle/queryKeyEleByTypeAndGroupId'),
    queryKeyEles: joinBaseUrl('/bpa/bizFlow/bfKeyEle/queryKeyEles'),
    queryKeyEleByIds: joinBaseUrl('/bpa/bizFlow/bfKeyEle/queryKeyEleByIds'),
    queryBfDepList: joinBaseUrl('/bpa/bpaOrg/bfDep/queryBfDepList'),
    queryBfFileByPost: joinBaseUrl('/bpa/bizFlow/project/queryBfFileByPost'),
    queryBfFileByBfPost: joinBaseUrl('/bpa/bpaOrg/bpaOrgProject/queryBfFileByBfPost'),
    

    // 回收站
    queryRecycleBfListByKey: joinBaseUrl('/bpa/bizFlow/bizFlow/queryRecycleBfListByKey'),
    recycleOrNo: joinBaseUrl('/bpa/bizFlow/bizFlow/recycleOrNo'),

    // 岗位职责
    queryDutyByBfPost: joinBaseUrl('/bpa/bpaOrg/bpaOrgProject/queryDutyByBfPost'),
    queryRelateBfByBfPost: joinBaseUrl('/bpa/bpaOrg/bpaOrgProject/queryRelateBfByBfPost'),
    queryKeyElesByBfPost: joinBaseUrl('/bpa/bizFlow/bfKeyPoint/left/queryKeyElesByBfPost'),
    queryKeyElesByPost: joinBaseUrl('/bpa/bizFlow/bfKeyPoint/top/queryKeyElesByBfPost'),
    queryDutyByPost: joinBaseUrl('/bpa/bizFlow/project/queryDutyByPost'),
    queryRelateBfByPost: joinBaseUrl('/bpa/bizFlow/project/queryRelateBfByPost'),

    //流程管理
    queryManagerBfListByEmpId: joinBaseUrl('/bpa/bizFlow/bfManager/queryManagerBfListByEmpId'),
    
    //流程小组
    getMyBfGroupList: joinBaseUrl('/bpa/bizFlow/bpaAuth/getMyBfGroupList'),
    queryBizFlowTreeByBfbgId: joinBaseUrl('/bpa/bizFlow/bizFlow/queryBizFlowTreeByBfgId'),

    // 流程反馈
    dealFeedBack: joinBaseUrl('/bpa/bizFlow/bfVer/feedback/dealFeedBack'),

    // 要素移动
    moveKeyEleGroup: joinBaseUrl('/bpa/bizFlow/bfKeyEle/moveKeyEleGroup'),
    moveKeyEle: joinBaseUrl('/bpa/bizFlow/bfKeyEle/moveKeyEle'),

    // 岗位移动
    adjustBfPostSeq: joinBaseUrl('/bpa/bpaOrg/bfDep/adjustBfPostSeq'),
    adjustBfPostSeqByPost: joinBaseUrl('/bpa/bpaOrg/bfPost/adjustBfPostSeq'),

    // 流程节点属性
    queryNodesAttr: joinBaseUrl('/bpa/bizFlow/bfStructGraph/bsgNode/queryNodesAttr'),

    // 流程关键节点
    addBfKeyPoint: joinBaseUrl('/bpa/bizFlow/bfKeyPoint/addBfKeyPoint'),
    deleteBfKeyPoint: joinBaseUrl('/bpa/bizFlow/bfKeyPoint/deleteBfKeyPoint'),
    queryBfKeyPoint: joinBaseUrl('/bpa/bizFlow/bfKeyPoint/queryBfKeyPoint'),
    updateBfKeyPoint: joinBaseUrl('/bpa/bizFlow/bfKeyPoint/updateBfKeyPoint'),
    queryBfKeyPointTreeByBfvId: joinBaseUrl('/bpa/bizFlow/bfKeyPoint/queryBfKeyPointTreeByBfvId'),
    adjustKeyPoint: joinBaseUrl('/bpa/bizFlow/bfKeyPoint/adjustKeyPoint'),
    queryKeyElesByBfKeyPoint: joinBaseUrl('/bpa/bizFlow/bfKeyPoint/queryKeyElesByBfKeyPoint'),
    queryRelateBfByPostKey: joinBaseUrl('/bpa/bizFlow/bfKeyPoint/queryRelateBfByPost'),
    queryRelateBfByPostId: joinBaseUrl('/bpa/bizFlow/bfKeyPoint/queryRelateBfByPostId'),

    
    queryBfFileVersionList: joinBaseUrl('/bpa/bizFlow/bfFileVersion/queryBfFileVersionList'),
    addBfFileVersion: joinBaseUrl('/bpa/bizFlow/bfFileVersion/addBfFileVersion'),
    saveFileVersion: joinBaseUrl('/bpa/bizFlow/bfFileVersion/saveFileVersion'),
    deleteBfFileVersion: joinBaseUrl('/bpa/bizFlow/bfFileVersion/deleteBfFileVersion'),
    queryBfFileVersion: joinBaseUrl('/bpa/bizFlow/bfFileVersion/queryBfFileVersion'),
  },
  app: {
    genSign: joinBaseUrl('/protal/appinvoke/gentblapi/genSign'),
    exportAppToFile: joinBaseUrl('/portal/appExport/appExport/exportAppToFile'),
    importAppFromFile: joinBaseUrl('/portal/appImport/appImport/importAppFromFile'),
    setStarApp: joinBaseUrl('/portal/app/app/setStarApp'),
    queryMyStarApps: joinBaseUrl('/portal/app/app/queryMyStarApps'),
    createApp: joinBaseUrl('/portal/app/app/createApp'),
    queryGroupsAndApps: joinBaseUrl('/portal/app/app/queryGroupsAndApps'),
    removeStarApp: joinBaseUrl('/portal/app/app/removeStarApp'),
    queryAllGroups: joinBaseUrl('/portal/app/app/queryAllGroups'),
    queryAppsByGroup: joinBaseUrl('/portal/app/app/queryAppsByGroup'),
    queryAppInfoById: joinBaseUrl('/portal/app/app/queryAppInfoById'),
    delApp: joinBaseUrl('/portal/app/app/delApp'),
    updateApp: joinBaseUrl('/portal/app/app/updateApp'),
    isAppAdmin: joinBaseUrl('/portal/app/appauth/control/appAuth/isAppAdmin'),
    hasAppMgtAuth: joinBaseUrl('/portal/app/appauth/control/hasAppMgtAuth'),
    queryAppsByKey: joinBaseUrl('/portal/app/app/queryAppsByKey'),
    queryAllMenuByKey: joinBaseUrl('/portal/app/appMenu/queryAllMenuByKey'),
    queryStarAppItemList: joinBaseUrl('/portal/app/starAppItem/queryStarAppItemList'),
    setStarAppItem: joinBaseUrl('/portal/app/starAppItem/setStarAppItem'),
    removeStarAppItem: joinBaseUrl('/portal/app/starAppItem/removeStarAppItem'),
    adjustStarAppItemSeq: joinBaseUrl('/portal/app/starAppItem/adjustStarAppItemSeq'),
    queryAmDtl: joinBaseUrl('/portal/app/appMenu/queryAmDtl'),
    adjustAgSeq: joinBaseUrl('/portal/app/appMgt/adjustAgSeq'),
    initIntegration: joinBaseUrl('/portal/apptpl/initOrgApp/initIntegration'),
    getInitResult: joinBaseUrl('/portal/apptpl/initOrgApp/getInitResult'),
    copyCustomIndex: joinBaseUrl('/index/customIndex/copyCustomIndex'),
    copyPortalPage: joinBaseUrl('/portal/portal/design/copyPortalPage'),
    copyAppPortal: joinBaseUrl('/portal/app/appMenu/copyAppPortal'),
    queryAllTblView: joinBaseUrl('/portal/workTbl/view/queryAllTblView'),
    queryAllReportFormView: joinBaseUrl('/portal/reportForm/config/queryAllReportFormView'),
    portal:{
      queryPortalPageList: joinBaseUrl('/portal/portal/design/queryPortalPageList'),
      addPortalPage: joinBaseUrl('/portal/portal/design/addPortalPage'),
      queryPortalPageSet: joinBaseUrl('/portal/portal/design/queryPortalPageSet'),
      savePortalPageSet: joinBaseUrl('/portal/portal/design/savePortalPageSet'),
      delPortalPage: joinBaseUrl('/portal/portal/design/delPortalPage'),
      updatePortalPage: joinBaseUrl('/portal/portal/design/updatePortalPage'),
      queryCurUserPortalDtl: joinBaseUrl('/portal/portal/portal/queryCurUserPortalDtl'),
      queryMyRoleList: joinBaseUrl('/portal/portal/portal/queryMyRoleList'),
      switchRole: joinBaseUrl('/portal/portal/portal/switchRole'),
      copyTbl: joinBaseUrl('/portal/app/appMenu/copyTbl'),
      adjustStarAppSeq: joinBaseUrl('/portal/app/app/adjustStarAppSeq'),
      queryCustomIndex: joinBaseUrl('/index/customIndex/queryCustomIndex'),
      editCustomIndex: joinBaseUrl('/index/customIndex/editCustomIndex'),
      addCustomIndex: joinBaseUrl('/index/customIndex/addCustomIndex'),
      updateCustomIndexInfo: joinBaseUrl('/index/customIndex/updateCustomIndexInfo'),
      delCustomIndex: joinBaseUrl('/index/customIndex/delCustomIndex'),
      queryAllCustomIndexList: joinBaseUrl('/index/customIndex/queryAllCustomIndexList'),
      queryCurCustomIndexList: joinBaseUrl('/index/customIndex/queryCurCustomIndexList'),
      queryApList: joinBaseUrl('/portal/portal/portal/queryApList'),
      adjustPortalPageSeq: joinBaseUrl('/portal/portal/design/adjustPortalPageSeq'),
      adjustCustomIndexSeq: joinBaseUrl('/index/customIndex/adjustCustomIndexSeq'),
    },
    appMenu: {
      addMenuGroup: joinBaseUrl('/portal/app/appMenu/addMenuGroup'),
      delMenuGroup: joinBaseUrl('/portal/app/appMenu/delMenuGroup'),
      editMenuGroup: joinBaseUrl('/portal/app/appMenu/editMenuGroup'),
      editMenuItem: joinBaseUrl('/portal/app/appMenu/editMenuItem'),
      delMenuItem: joinBaseUrl('/portal/app/appMenu/delMenuItem'),
      addMenuItem: joinBaseUrl('/portal/app/appMenu/addMenuItem'),
      queryMenuTree: joinBaseUrl('/portal/app/appMenu/queryMenuTree'),
      adjustSeq: joinBaseUrl('/portal/app/appMenu/adjustSeq'),
      queryFirstLevelGroup: joinBaseUrl('/portal/app/appMenu/queryFirstLevelGroup'),
      moveMenuItemGroup: joinBaseUrl('/portal/app/appMenu/moveMenuItemGroup'),
      dragOrder: joinBaseUrl('/portal/app/appMenu/dragOrder'),
    },
    appauth: {
      queryRoleListByApp: joinBaseUrl('/portal/app/appauth/config/appRoleConfig/queryRoleListByApp'),
      addRole: joinBaseUrl('/portal/app/appauth/config/appRoleConfig/addRole'),
      updateRole: joinBaseUrl('/portal/app/appauth/config/appRoleConfig/updateRole'),
      delRole: joinBaseUrl('/portal/app/appauth/config/appRoleConfig/delRole'),
      queryMemListByRole: joinBaseUrl('/portal/app/appauth/config/appRoleConfig/queryMemListByRole'),
      addRoleMem: joinBaseUrl('/portal/app/appauth/config/appRoleConfig/addRoleMem'),
      delRoleMem: joinBaseUrl('/portal/app/appauth/config/appRoleConfig/delRoleMem'),
      addAppItemAuth: joinBaseUrl('/portal/app/appauth/config/appAuthConfig/addAppItemAuth'),
      updateAppItemAuth: joinBaseUrl('/portal/app/appauth/config/appAuthConfig/updateAppItemAuth'),
      delAppItemAuth: joinBaseUrl('/portal/app/appauth/config/appAuthConfig/delAppItemAuth'),
      queryAppItemAuth: joinBaseUrl('/portal/app/appauth/config/appAuthConfig/queryAppItemAuth'),
      hasOrgMgtAuth: joinBaseUrl('/portal/app/appauth/control/hasOrgMgtAuth'),
      queryWorkTblAuth: joinBaseUrl('/portal/app/appauth/config/appAuthConfig/queryWorkTblAuth'),
      delWorkTblAuth: joinBaseUrl('/portal/app/appauth/config/appAuthConfig/delWorkTblAuth'),
      updateWorkTblAuth: joinBaseUrl('/portal/app/appauth/config/appAuthConfig/updateWorkTblAuth'),
      addWorkTblAuth: joinBaseUrl('/portal/app/appauth/config/appAuthConfig/addWorkTblAuth'),
      queryAppItemAuthList: joinBaseUrl('/portal/app/appauth/config/appAuthConfig/queryAppItemAuthList'),
      batchAddAppItemAuth: joinBaseUrl('/portal/app/appauth/config/appAuthConfig/batchAddAppItemAuth'),
      batchDelAppItemAuth: joinBaseUrl('/portal/app/appauth/config/appAuthConfig/batchDelAppItemAuth'),
      queryWorkTblAuthList: joinBaseUrl('/portal/app/appauth/config/appAuthConfig/queryWorkTblAuthList'),
      batchAddWorkTblAuth: joinBaseUrl('/portal/app/appauth/config/appAuthConfig/batchAddWorkTblAuth'),
      batchDelWorkTblAuth: joinBaseUrl('/portal/app/appauth/config/appAuthConfig/batchDelWorkTblAuth'),
      
    },
    appMgt: {
      queryAppGroupList: joinBaseUrl('/portal/app/appMgt/queryAppGroupList'),
      addAppGroup: joinBaseUrl('/portal/app/appMgt/addAppGroup'),
      updateAppGroup: joinBaseUrl('/portal/app/appMgt/updateAppGroup'),
      delAppGroup: joinBaseUrl('/portal/app/appMgt/delAppGroup'),
      queryAppByGroup: joinBaseUrl('/portal/app/appMgt/queryAppByGroup'),
      moveAppGroup: joinBaseUrl('/portal/app/appMgt/moveAppGroup'),
      queryAllRecycle: joinBaseUrl('/portal/app/appRecycleMgt/queryAllRecycle'),
      addAppRecycle: joinBaseUrl('/portal/app/appRecycleMgt/addAppRecycle'),
      restoreApp: joinBaseUrl('/portal/app/appRecycleMgt/restoreApp'),
      restoreAllApp: joinBaseUrl('/portal/app/appRecycleMgt/restoreAllApp'),
    }
  },
  report:{
    
    addReportFormView:joinBaseUrl('/portal/reportForm/config/addReportFormView'),
    editReportFormView:joinBaseUrl('/portal/reportForm/config/editReportFormView'),
    delReportFormView:joinBaseUrl('/portal/reportForm/config/delReportFormView'),
    queryReportFormViewList:joinBaseUrl('/portal/reportForm/config/queryReportFormViewList'),
    queryReportFormViewListByEmp:joinBaseUrl('/portal/reportForm/reportForm/queryReportFormViewList'),
    copyReportFormView:joinBaseUrl('/portal/reportForm/config/copyReportFormView'),
    adjustReportFormViewSeq:joinBaseUrl('/portal/reportForm/config/adjustReportFormViewSeq'),
    report:{
      queryByGroup: joinBaseUrl('/portal/report/report/queryByGroup'),
    },
    reportDtl:{
      // 
      queryDiagramData: joinBaseUrl('/portal/page/reportData/queryDiagramData'),
    }
  },
  page:{

    queryPageSet: joinBaseUrl('/portal/page/design/queryPageSet'),
    savePageSet: joinBaseUrl('/portal/page/design/savePageSet'),
    queryPageViewData: joinBaseUrl('/portal/page/viewData/queryPageViewData'),
  },
  bigScreen:{
    queryBigScreenSet: joinBaseUrl('/portal/bigScreen/bigScreen/queryBigScreenSet'),
    saveBigScreenSet: joinBaseUrl('/portal/bigScreen/bigScreen/saveBigScreenSet'),
  },
  view:{
    getVcDIYSetStatus: joinBaseUrl('/viewCollect/viewCollectDesign/getVcDIYSetStatus'),
    changeVcDIYSetStatus: joinBaseUrl('/viewCollect/viewCollectDesign/changeVcDIYSetStatus'),
    queryVcStruct: joinBaseUrl('/viewCollect/viewCollectDesign/queryVcStruct'),
    saveVcStruct: joinBaseUrl('/viewCollect/viewCollectDesign/saveVcStruct'),
  },
  worktbl:{
    saveFormStruct: joinBaseUrl('/portal/workTbl/config/saveFormStruct'),
    queryFormStruct: joinBaseUrl('/portal/workTbl/config/queryFormStruct'),
    addFormRow: joinBaseUrl('/portal/workTbl/detail/addFormRow'),
    queryDataByRelatedFld: joinBaseUrl('/portal/workTbl/detail/queryDataByRelatedFld'),
    queryFormRowById: joinBaseUrl('/portal/workTbl/detail/queryFormRowById'),
    updateFormRow: joinBaseUrl('/portal/workTbl/detail/updateFormRow'),
    delFormRow: joinBaseUrl('/portal/workTbl/detail/delFormRow'),
    queryFormDtlStruct: joinBaseUrl('/portal/workTbl/detail/queryFormDtlStruct'),
    queryHasAuthLayoutList: joinBaseUrl('/portal/workTbl/detail/queryHasAuthLayoutList'),
    queryMenuName: joinBaseUrl('/portal/app/appMenu/queryMenuName'),
    queryExcelStruct: joinBaseUrl('/portal/workTbl/view/queryExcelStruct'),
    queryFldsByTblId: joinBaseUrl('/portal/workTbl/config/queryFldsByTblId'),
    queryAppInfoByWtId: joinBaseUrl('/portal/app/app/queryAppInfoByWtId'),
    queryTblsByAppId: joinBaseUrl('/portal/app/app/queryTblsByAppId'),
    queryAllApps: joinBaseUrl('/portal/app/app/queryAllApps'),
    queryViewListByWtId: joinBaseUrl('/portal/workTbl/view/queryViewListByWtId'),
    addView: joinBaseUrl('/portal/workTbl/view/addView'),
    copyViewFromId: joinBaseUrl('/portal/workTbl/view/copyViewFromId'),
    delViewById: joinBaseUrl('/portal/workTbl/view/delViewById'),
    updateViewNameById: joinBaseUrl('/portal/workTbl/view/updateViewNameById'),
    querySessionMap: joinBaseUrl('/session/querySessionMap'),
    uploadPublicFile: joinBaseUrl('/svr/file/manager/file/uploadPublicFile'),
    uploadPrivateFile: joinBaseUrl('/svr/file/manager/file/uploadPrivateFile'),
    getFileUrl: joinBaseUrl('/svr/file/manager/file/getFileUrl'),
    queryLinkRow: joinBaseUrl('/portal/workTbl/detail/queryLinkRow'),
    queryRelatePage: joinBaseUrl('/portal/workTbl/detail/queryRelatePage'),
    queryViewDataById: joinBaseUrl('/portal/workTbl/view/queryViewDataById'),
    queryViewGroup: joinBaseUrl('/portal/workTbl/view/queryViewGroup'),
    queryDtlById: joinBaseUrl('/portal/workTbl/view/queryDtlById'),
    updateSetViewById: joinBaseUrl('/portal/workTbl/view/updateSetViewById'),
    batchDelRowsByIds: joinBaseUrl('/portal/workTbl/detail/batchDelRowsByIds'),
    batchUpdateFormFld: joinBaseUrl('/portal/workTbl/detail/batchUpdateFormFld'),
    saveBizRule: joinBaseUrl('/portal/workTbl/config/saveBizRule'),
    queryBizRule: joinBaseUrl('/portal/workTbl/config/queryBizRule'),
    queryFormStructByViewId: joinBaseUrl('/portal/workTbl/view/queryFormStruct'),
    queryRowDtlByViewId: joinBaseUrl('/portal/workTbl/view/queryRowDtlByViewId'),
    savePubSet: joinBaseUrl('/portal/workTbl/config/savePubSet'),
    queryPubSet: joinBaseUrl('/portal/workTbl/config/queryPubSet'),
    open: joinBaseUrl('/portal/workTbl/config/open'),
    close: joinBaseUrl('/portal/workTbl/config/close'),
    queryPubStatus: joinBaseUrl('/portal/workTbl/config/queryPubStatus'),
    queryPubFormSet: joinBaseUrl('/pub/portal/workTbl/pub/queryPubFormSet'),
    submitPubForm: joinBaseUrl('/pub/portal/workTbl/pub/submitPubForm'),
    queryProvinceList: joinBaseUrl('/pub/common/area/area/queryProvinceList'),
    queryDstListByCity: joinBaseUrl('/pub/common/area/area/queryDstListByCity'),
    queryCityListByPro: joinBaseUrl('/pub/common/area/area/queryCityListByPro'),
    queryTblAuthDtl: joinBaseUrl('/portal/app/appauth/control/appAuth/queryTblAuthDtl'),
    dragLineOrder: joinBaseUrl('/portal/workTbl/view/dragLineOrder'),
    saveValidateRule: joinBaseUrl('/portal/workTbl/config/saveValidateRule'),
    queryValidateRule: joinBaseUrl('/portal/workTbl/config/queryValidateRule'),
    aiflow:joinBaseUrl('/ai/aiflow'),
    queryBtnFlowList: joinBaseUrl('/bpm/def/flowDef/queryBtnFlowList'),
    clickDtlBtnTriggerFlow: joinBaseUrl('/portal/workTbl/list/clickDtlBtnTriggerFlow'),
    clickDtlBtnSaveForm: joinBaseUrl('/portal/workTbl/list/clickDtlBtnSaveForm'),
    queryIsOpen: joinBaseUrl('/portal/workTbl/config/queryIsOpen'),
    openCstDtl: joinBaseUrl('/portal/workTbl/config/openCstDtl'),
    closeCstDtl: joinBaseUrl('/portal/workTbl/config/closeCstDtl'),
    saveBaseSet: joinBaseUrl('/portal/workTbl/config/saveBaseSet'),
    queryBaseSet: joinBaseUrl('/portal/workTbl/config/queryBaseSet'),
    queryWtKpDtl: joinBaseUrl('/portal/workTbl/detail/queryWtKpDtl'),

    addListCstBtn: joinBaseUrl('/portal/workTbl/config/addListCstBtn'),
    addDtlCstBtn: joinBaseUrl('/portal/workTbl/config/addDtlCstBtn'),
    updateDtlCstBtn: joinBaseUrl('/portal/workTbl/config/updateDtlCstBtn'),
    updateListCstBtn: joinBaseUrl('/portal/workTbl/config/updateListCstBtn'),
    delDtlCstBtn: joinBaseUrl('/portal/workTbl/config/delDtlCstBtn'),
    delListCstBtn: joinBaseUrl('/portal/workTbl/config/delListCstBtn'),
    queryDtlCstBtnList: joinBaseUrl('/portal/workTbl/config/queryDtlCstBtnList'),
    listQueryDtlCstBtnList: joinBaseUrl('/portal/workTbl/list/queryDtlCstBtnList'),
    queryListCstBtnList: joinBaseUrl('/portal/workTbl/config/queryListCstBtnList'),
    queryCstDtl: joinBaseUrl('/portal/workTbl/cstdtl/queryCstDtl'),
    queryCstDtlConfig: joinBaseUrl('/portal/workTbl/config/queryCstDtl'),
    saveCstDtl: joinBaseUrl('/portal/workTbl/config/saveCstDtl'),
    getExcelData: joinBaseUrl('/portal/workTbl/list/getExcelData'),
    importFromExcel: joinBaseUrl('/portal/workTbl/list/importFromExcel'),
    tableDataExport: joinBaseUrl('/portal/app/exportAllViewData'),
    checkTask: joinBaseUrl('/portal/app/checkTask'),
    exportChooseData: joinBaseUrl('/portal/app/exportChooseData'),
    orderBtn: joinBaseUrl('/portal/workTbl/config/orderBtn'),
    queryEmpMainDep: joinBaseUrl('/org/user/emp/queryEmpMainDep'),
    queryEmpPostList: joinBaseUrl('/org/user/emp/queryEmpPostList'),
    queryEmpListByKey: joinBaseUrl('/org/user/emp/queryEmpListByKey'),
    queryDepListByKey: joinBaseUrl('/org/user/contact/queryDepListByKey'),
    queryPostByCond: joinBaseUrl('/org/user/post/queryPostByCond'),
    addPrintTpl: joinBaseUrl('/portal/workTbl/config/addPrintTpl'),
    queryPrintTpl: joinBaseUrl('/portal/workTbl/config/queryPrintTpl'),
    queryRelateTblTplList: joinBaseUrl('/portal/workTbl/print/queryRelateTblTplList'),
    relateTblTplPrint: joinBaseUrl('/portal/workTbl/print/relateTblTplPrint'),
    delPrintTpl: joinBaseUrl('/portal/workTbl/config/delPrintTpl'),
    updatePrintTpl: joinBaseUrl('/portal/workTbl/config/updatePrintTpl'),
    tplprint: joinBaseUrl('/portal/workTbl/print/tplprint'),
    queryTwoTplList: joinBaseUrl('/portal/workTbl/print/queryTwoTplList'),
    queryStripTplList: joinBaseUrl('/portal/workTbl/print/queryStripTplList'),
    querySysAndWordTplList: joinBaseUrl('/portal/workTbl/print/querySysAndWordTplList'),
    queryRowDisplayValue: joinBaseUrl('/portal/workTbl/detail/queryRowDisplayValue'),
    adjustViewSeq: joinBaseUrl('/portal/workTbl/view/adjustViewSeq'),
    batchPass: joinBaseUrl('/bpm/workbentch/dtl/flowTaskOp/batchPass'),
    batchRefuse: joinBaseUrl('/bpm/workbentch/dtl/flowTaskOp/batchRefuse'),
    excelTplprint: joinBaseUrl('/portal/workTbl/print/excelTplprint'),
    queryExcelTplList: joinBaseUrl('/portal/workTbl/print/queryExcelTplList'),
    saveCollaborateSet: joinBaseUrl('/portal/workTbl/config/saveCollaborateSet'),
    queryCollaborateSet: joinBaseUrl('/portal/workTbl/config/queryCollaborateSet'),
    updateFormFld: joinBaseUrl('/portal/workTbl/detail/updateFormFld'),
    updateRelateKnow: joinBaseUrl('/portal/workTbl/detail/updateRelateKnow'),
// ------------------------
    queryViewListByVcId: joinBaseUrl('/viewCollect/viewCollect/queryViewListByVcId'),
    queryVcViewDtl: joinBaseUrl('/viewCollect/viewCollect/queryVcViewDtl'),
    addVcView: joinBaseUrl('/viewCollect/viewCollect/addVcView'),
    delVcView: joinBaseUrl('/viewCollect/viewCollect/delVcView'),
    adjustVcViewSeq: joinBaseUrl('/viewCollect/viewCollect/adjustVcViewSeq'),
    queryVcWtId: joinBaseUrl('/viewCollect/viewCollectDesign/queryVcWtId'),
    queryAuthAppItemTree: joinBaseUrl('/portal/app/appauth/config/appAuthConfig/queryAuthAppItemTree'),
    queryAlternateItemByAppId: joinBaseUrl('/portal/app/app/queryAlternateItemByAppId'),
    queryDataCount: joinBaseUrl('/portal/workTbl/view/queryDataCount'),
    queryVcListByWtId: joinBaseUrl('/portal/workTbl/config/queryVcListByWtId'),
// ---------------
    addTableLayout: joinBaseUrl('/portal/workTbl/config/addTableLayout'),
    copyTableLayout: joinBaseUrl('/portal/workTbl/config/copyTableLayout'),
    editTableLayout: joinBaseUrl('/portal/workTbl/config/editTableLayout'),
    delTableLayout: joinBaseUrl('/portal/workTbl/config/delTableLayout'),
    queryTableLayoutList: joinBaseUrl('/portal/workTbl/config/queryTableLayoutList'),
    queryTableLayoutDtl: joinBaseUrl('/portal/workTbl/config/queryTableLayoutDtl'),
    queryOpenLayoutList: joinBaseUrl('/portal/workTbl/detail/queryOpenLayoutList'),

    addRowDraft: joinBaseUrl('/portal/workTbl/rowDraft/addRowDraft'),
    updateRowDraft: joinBaseUrl('/portal/workTbl/rowDraft/updateRowDraft'),
    delRowDraft: joinBaseUrl('/portal/workTbl/rowDraft/delRowDraft'),
    queryRowDraftList: joinBaseUrl('/portal/workTbl/rowDraft/queryRowDraftList'),
    
    addFrontEvent: joinBaseUrl('/portal/workTbl/frontEvent/config/addFrontEvent'),
    editFrontEvent: joinBaseUrl('/portal/workTbl/frontEvent/config/editFrontEvent'),
    delFrontEvent: joinBaseUrl('/portal/workTbl/frontEvent/config/delFrontEvent'),
    queryFrontEventDtl: joinBaseUrl('/portal/workTbl/frontEvent/config/queryFrontEventDtl'),
    queryFrontEventList: joinBaseUrl('/portal/workTbl/frontEvent/config/queryFrontEventList'),
    testFrontEventApi: joinBaseUrl('/portal/workTbl/frontEvent/config/testFrontEventApi'),
    testFrontEventModel: joinBaseUrl('/portal/workTbl/frontEvent/config/testFrontEventModel'),
    queryFrontEventListUser: joinBaseUrl('/portal/workTbl/frontEvent/user/queryFrontEventList'),
    getFrontEventResponseStruct: joinBaseUrl('/portal/workTbl/frontEvent/config/getFrontEventResponseStruct'),
    trigerFrontEvent: joinBaseUrl('/portal/workTbl/frontEvent/user/trigerFrontEvent'),
    adjustTlSeq: joinBaseUrl('/portal/workTbl/config/adjustTlSeq'),
    queryTlCorrespondence: joinBaseUrl('/portal/workTbl/detail/queryTlCorrespondence'),

    queryVcLayoutList: joinBaseUrl('/viewCollect/viewCollect/queryVcLayoutList'),
    queryVcDtl: joinBaseUrl('/viewCollect/viewCollectDesign/queryVcDtl'),
    saveVcLayoutList: joinBaseUrl('/viewCollect/viewCollectDesign/saveVcLayoutList'),
    getRelateProcessData: joinBaseUrl('/portal/workTbl/detail/getRelateProcessData'),
    getCurRowDraftNum: joinBaseUrl('/portal/workTbl/rowDraft/getCurRowDraftNum'),
    manualRelateKnow: joinBaseUrl('/portal/workTbl/detail/manualRelateKnow'),
    
    batchUploadKnowFile: joinBaseUrl('/portal/workTbl/knowOperate/batchUploadKnowFile'),
    tabQueryKnPageDtl: joinBaseUrl('/portal/workTbl/knowOperate/tabQueryKnPageDtl'),
    tabAddKnPage: joinBaseUrl('/portal/workTbl/knowOperate/tabAddKnPage'),
    tabAddFileVer: joinBaseUrl('/portal/workTbl/knowOperate/tabAddFileVer'),
    tabAddKpOpHistory: joinBaseUrl('/portal/workTbl/knowOperate/tabAddKpOpHistory'),
    
    editRowAuth: joinBaseUrl('/portal/workTbl/rowAuth/editRowAuth'),
    queryRowAuth: joinBaseUrl('/portal/workTbl/rowAuth/queryRowAuth'),
    transferOwner: joinBaseUrl('/portal/workTbl/rowAuth/transferOwner'),
    setFacilitator: joinBaseUrl('/portal/workTbl/rowAuth/setFacilitator'),
    queryRowMember: joinBaseUrl('/portal/workTbl/rowAuth/queryRowMember'),
    queryCurUserRowAuth: joinBaseUrl('/portal/workTbl/rowAuth/queryCurUserRowAuth'),
    allocationOwner: joinBaseUrl('/portal/workTbl/rowAuth/allocationOwner'),

    addCustomFilter: joinBaseUrl('/portal/workTbl/view/customFilter/addCustomFilter'),
    editCustomFilter: joinBaseUrl('/portal/workTbl/view/customFilter/editCustomFilter'),
    delCustomFilter: joinBaseUrl('/portal/workTbl/view/customFilter/delCustomFilter'),
    pinCustomFilter: joinBaseUrl('/portal/workTbl/view/customFilter/pinCustomFilter'),
    getPinCustomFilter: joinBaseUrl('/portal/workTbl/view/customFilter/getPinCustomFilter'),
    adjustCustomFilter: joinBaseUrl('/portal/workTbl/view/customFilter/adjustCustomFilter'),
    queryCustomFilterListByView: joinBaseUrl('/portal/workTbl/view/customFilter/queryCustomFilterListByView'),
    queryRelateBpaSet: joinBaseUrl('/portal/workTbl/config/queryRelateBpaSet'),
    saveRelateBpaSet: joinBaseUrl('/portal/workTbl/config/saveRelateBpaSet'),
    queryRelateBpaBfInfo: joinBaseUrl('/portal/workTbl/config/queryRelateBpaBfInfo'),

    addTask:joinBaseUrl('/portal/workTbl/taskTab/addTask'),
    updateTask:joinBaseUrl('/portal/workTbl/taskTab/updateTask'),
    delTask:joinBaseUrl('/portal/workTbl/taskTab/delTask'),
    queryTaskDtl:joinBaseUrl('/portal/workTbl/taskTab/queryTaskDtl'),
    completeTask:joinBaseUrl('/portal/workTbl/taskTab/completeTask'),
    queryTaskListByWtAndRowId:joinBaseUrl('/portal/workTbl/taskTab/queryTaskListByWtAndRowId'),
    queryDefPageByCond:joinBaseUrl('/portal/workTbl/taskTab/queryDefPageByCond'),
    addScheduleCircleTask:joinBaseUrl('/portal/task/scheduleCircleTask/add'),
    updateScheduleCircleTask:joinBaseUrl('/portal/task/scheduleCircleTask/update'),
    delScheduleCircleTask:joinBaseUrl('/portal/task/scheduleCircleTask/del'),
    changeScheduleCircleTaskStatus:joinBaseUrl('/portal/task/scheduleCircleTask/changeStatus'),
    listScheduleCircleTask:joinBaseUrl('/portal/task/scheduleCircleTask/list'),
    addSchedule:joinBaseUrl('/portal/workTbl/schTab/addSchedule'),
    editSchedule:joinBaseUrl('/portal/workTbl/schTab/editSchedule'),
    delSchedule:joinBaseUrl('/portal/workTbl/schTab/delSchedule'),
    queryScheduleDtl:joinBaseUrl('/portal/workTbl/schTab/queryScheduleDtl'),
    queryScheduleListByWtAndRowId:joinBaseUrl('/portal/workTbl/schTab/queryScheduleListByWtAndRowId'),

    queryFlowCstBtnList:joinBaseUrl('/portal/workTbl/list/queryFlowCstBtnList'),
    batchTriggerFlow:joinBaseUrl('/portal/workTbl/list/batchTriggerFlow'),
    querySysTplList:joinBaseUrl('/portal/workTbl/print/querySysTplList'),
    queryCurUpEmp:joinBaseUrl('/org/user/emp/queryCurUpEmp'),

    getListRelateTblData:joinBaseUrl('/portal/workTbl/detail/getListRelateTblData'),

    addWtDtlSet:joinBaseUrl('/portal/workTbl/config/addWtDtlSet'),
    editWtDtlSet:joinBaseUrl('/portal/workTbl/config/editWtDtlSet'),
    queryWdsByType:joinBaseUrl('/portal/workTbl/config/queryWdsByType'),
    addWtDtlLabel:joinBaseUrl('/portal/workTbl/config/addWtDtlLabel'),
    editWtDtlLabel:joinBaseUrl('/portal/workTbl/config/editWtDtlLabel'),
    delWtDtlLabel:joinBaseUrl('/portal/workTbl/config/delWtDtlLabel'),
    queryWdlabDtl:joinBaseUrl('/portal/workTbl/config/queryWdlabDtl'),
    queryWdlabList:joinBaseUrl('/portal/workTbl/config/queryWdlabList'),
    adjustWdlabSeq:joinBaseUrl('/portal/workTbl/config/adjustWdlabSeq'),

    queryCurCstDtl:joinBaseUrl('/portal/workTbl/cstdtl/queryCurCstDtl'),
    queryWdlabDtlNormal:joinBaseUrl('/portal/workTbl/cstdtl/queryWdlabDtl'),
    queryCstDtlNormal:joinBaseUrl('/portal/workTbl/cstdtl/queryCstDtl'),
    queryCstDtlRelatePage:joinBaseUrl('/portal/workTbl/detail/queryCstDtlRelatePage'),

    examine:joinBaseUrl('/portal/workTbl/detail/examine'),
    cancelExamine:joinBaseUrl('/portal/workTbl/detail/cancelExamine'),
    batchExamine:joinBaseUrl('/portal/workTbl/detail/batchExamine'),
    batchCancelExamine:joinBaseUrl('/portal/workTbl/detail/batchCancelExamine'),

    queryReportRelationTypeList:joinBaseUrl('/org/user/contact/queryReportRelationTypeList'),
    queryEmpSuperReportRelation:joinBaseUrl('/org/user/contact/queryEmpSuperReportRelation'),
    queryDepDtl:joinBaseUrl('/org/user/contact/queryDepDtl'),
    
    queryCustomFormulaConfig:joinBaseUrl('/portal/workTbl/config/queryCustomFormula'),
    saveCustomFormula:joinBaseUrl('/portal/workTbl/config/saveCustomFormula'),
    queryCustomFormula:joinBaseUrl('/portal/workTbl/customformula/queryCustomFormula'),
    calFldValue:joinBaseUrl('/portal/workTbl/customformula/calFldValue'),


  },
  flowInCharge:{
    querFicvList:joinBaseUrl('/flowInCharge/flowInChargeConfig/querFicvList'),
    copyFicv:joinBaseUrl('/flowInCharge/flowInChargeConfig/copyFicv'),
    pubFicv:joinBaseUrl('/flowInCharge/flowInChargeConfig/pubFicv'),
    delFicv:joinBaseUrl('/flowInCharge/flowInChargeConfig/delFicv'),
    addFicv:joinBaseUrl('/flowInCharge/flowInChargeConfig/addFicv'),

    getFlowInChargeTree:joinBaseUrl('/flowInCharge/flowInChargeConfig/getFlowInChargeTree'),
    queryRowSanRelateList:joinBaseUrl('/flowInCharge/flowInCharge/queryRowSanRelateList'),
    addSan:joinBaseUrl('/flowInCharge/flowInChargeConfig/addSan'),
    editSan:joinBaseUrl('/flowInCharge/flowInChargeConfig/editSan'),
    delSan:joinBaseUrl('/flowInCharge/flowInChargeConfig/delSan'),
    adjustSanSeq:joinBaseUrl('/flowInCharge/flowInChargeConfig/adjustSanSeq'),
    adjustSanBtnSeq:joinBaseUrl('/flowInCharge/flowInChargeConfig/adjustSanBtnSeq'),
    adjustSanDataSeq:joinBaseUrl('/flowInCharge/flowInChargeConfig/adjustSanDataSeq'),

    querySanBtnList:joinBaseUrl('/flowInCharge/flowInChargeConfig/querySanBtnList'),
    addSanBtn:joinBaseUrl('/flowInCharge/flowInChargeConfig/addSanBtn'),
    editSanBtn:joinBaseUrl('/flowInCharge/flowInChargeConfig/editSanBtn'),
    delSanBtn:joinBaseUrl('/flowInCharge/flowInChargeConfig/delSanBtn'),

    querySanDataList:joinBaseUrl('/flowInCharge/flowInChargeConfig/querySanDataList'),
    addSanData:joinBaseUrl('/flowInCharge/flowInChargeConfig/addSanData'),
    editSanData:joinBaseUrl('/flowInCharge/flowInChargeConfig/editSanData'),
    delSanData:joinBaseUrl('/flowInCharge/flowInChargeConfig/delSanData'),
    clickCanComplete: joinBaseUrl('/flowInCharge/flowInCharge/clickCanComplete'),
    cutRowSanRelate: joinBaseUrl('/flowInCharge/flowInCharge/cutRowSanRelate'),
    
    queryFicList: joinBaseUrl('/flowInCharge/flowInChargeConfig/queryFicList'),
    addFic: joinBaseUrl('/flowInCharge/flowInChargeConfig/addFic'),
    copyFic: joinBaseUrl('/flowInCharge/flowInChargeConfig/copyFic'),
    editFic: joinBaseUrl('/flowInCharge/flowInChargeConfig/editFic'),
    delFic: joinBaseUrl('/flowInCharge/flowInChargeConfig/delFic'),

    editFicv: joinBaseUrl('/flowInCharge/flowInChargeConfig/editFicv'),
    exportFlowInChargeTableDtl: joinBaseUrl('/flowInCharge/flowInCharge/exportFlowInChargeTableDtl'),
    querFicvDtl: joinBaseUrl('/flowInCharge/flowInChargeConfig/querFicvDtl'),

  },
  flowInChargeSet:{
    getFlowInChargeTree:joinBaseUrl('/flowInCharge/flowInCharge/getFlowInChargeTree'),
    queryCurFicv:joinBaseUrl('/flowInCharge/flowInCharge/queryCurFicv'),
    querySanSet:joinBaseUrl('/flowInCharge/flowInCharge/querySanSet'),
    clickSanBtnSaveForm:joinBaseUrl('/flowInCharge/flowInCharge/clickSanBtnSaveForm'),
    clickSanBtnComp:joinBaseUrl('/flowInCharge/flowInCharge/clickSanBtn'),
    clickSanBtnTriggerFlow:joinBaseUrl('/flowInCharge/flowInCharge/clickSanBtnTriggerFlow'),
    setRowSanInfo:joinBaseUrl('/flowInCharge/flowInCharge/setRowSanInfo'),
    setNextCharger:joinBaseUrl('/flowInCharge/flowInCharge/setNextCharger'),
    setPlanTime:joinBaseUrl('/flowInCharge/flowInCharge/setPlanTime'),
    querySanInfoByIds:joinBaseUrl('/flowInCharge/flowInCharge/querySanInfoByIds'),
  },
  org:{
    empMgt: {
      queryEmpPageByCond: joinBaseUrl('/org/mgt/empMgt/queryEmpPageByCond'),
      queryEmpByCond: joinBaseUrl('/org/mgt/empMgt/queryEmpByCond'),
      addEmp: joinBaseUrl('/org/mgt/empMgt/addEmp'),
      updateEmp: joinBaseUrl('/org/mgt/empMgt/updateEmp'),
      setMainDep: joinBaseUrl('/org/mgt/empMgt/setMainDep'),
      queryEmpDtl: joinBaseUrl('/org/mgt/empMgt/queryEmpDtl'),
      queryNoDepEmpPageByCond: joinBaseUrl('/org/mgt/empMgt/queryNoDepEmpPageByCond'),
      queryNoDepEmpByCond: joinBaseUrl('/org/mgt/empMgt/queryNoDepEmpByCond'),
      disableEmp: joinBaseUrl('/org/mgt/empMgt/disableEmp'),
      recoveryEmp: joinBaseUrl('/org/mgt/empMgt/recoveryEmp'),
      resetEmpPswd: joinBaseUrl('/org/mgt/empMgt/resetEmpPswd'),
      delOrgEmp: joinBaseUrl('/org/mgt/empMgt/delOrgEmp'),
      queryEmpUpDownTree: joinBaseUrl('/org/mgt/empMgt/queryEmpUpDownTree'),
      initUpDownTree: joinBaseUrl('/org/mgt/empMgt/initUpDownTree'),
      changeUper: joinBaseUrl('/org/mgt/empMgt/changeUper'),
      exportOrgEmp: joinBaseUrl('/org/mgt/empMgt/exportOrgEmp'),
      getOrgEmpTpl: joinBaseUrl('/org/mgt/empMgt/getOrgEmpTpl'),
      importOrgEmpFromExcel: joinBaseUrl('/org/mgt/empMgt/importOrgEmpFromExcel'),
    },
    depMgt: {
      addDep: joinBaseUrl('/org/mgt/depMgt/addDep'),
      updateDepInfo: joinBaseUrl('/org/mgt/depMgt/updateDepInfo'),
      delDepById: joinBaseUrl('/org/mgt/depMgt/delDepById'),
      queryDepTree: joinBaseUrl('/org/mgt/depMgt/queryDepTree'),
      queryDepInfoById: joinBaseUrl('/org/mgt/depMgt/queryDepInfoById'),
      adjustDepOrder: joinBaseUrl('/org/mgt/depMgt/adjustDepOrder'),
      updateDepCharge: joinBaseUrl('/org/mgt/depMgt/updateDepCharge'),
      exportAllDep: joinBaseUrl('/org/mgt/depMgt/exportAllDep'),
      getDepTpl: joinBaseUrl('/org/mgt/depMgt/getDepTpl'),
      importDepFromExcel: joinBaseUrl('/org/mgt/depMgt/importDepFromExcel'),
    },
    depEmpMgt: {
      addDepEmp: joinBaseUrl('/org/mgt/depEmpMgt/addDepEmp'),
      delDepEmp: joinBaseUrl('/org/mgt/depEmpMgt/delDepEmp'),
      moveDepEmp: joinBaseUrl('/org/mgt/depEmpMgt/moveDepEmp'),
      queryExternalEmpListByCond: joinBaseUrl('/org/mgt/externalEmpMgt/queryExternalEmpListByCond'),
      queryExternalEmpGroupList: joinBaseUrl('/org/mgt/externalEmpGroupMgt/queryExternalEmpGroupList'),
      addExternalEmpGroup: joinBaseUrl('/org/mgt/externalEmpGroupMgt/addExternalEmpGroup'),
      editExternalEmpGroup: joinBaseUrl('/org/mgt/externalEmpGroupMgt/editExternalEmpGroup'),
      delExternalEmpGroup: joinBaseUrl('/org/mgt/externalEmpGroupMgt/delExternalEmpGroup'),
      changeExternalEmpStatus: joinBaseUrl('/org/mgt/externalEmpMgt/changeExternalEmpStatus'),
      dealExternalEmpApply: joinBaseUrl('/org/mgt/externalEmpMgt/dealExternalEmpApply'),
      resetExternalEmpPswd: joinBaseUrl('/org/mgt/externalEmpMgt/resetExternalEmpPswd'),
      delExternalEmp: joinBaseUrl('/org/mgt/externalEmpMgt/delExternalEmp'),
      moveExternalEmp: joinBaseUrl('/org/mgt/externalEmpMgt/moveExternalEmp'),
      mgtAddExternalEmp: joinBaseUrl('/org/mgt/externalEmpMgt/mgtAddExternalEmp'),
    },
    user:{
      setNewGuide: joinBaseUrl('/org/user/user/setNewGuide'),
      queryUserDtl: joinBaseUrl('/org/user/user/queryUserDtl'),
      updateUserInfo: joinBaseUrl('/org/user/user/updateUserInfo'),
      updatePswd: joinBaseUrl('/org/user/user/updatePswd'),
      updateMail: joinBaseUrl('/org/user/user/updateMail'),
      updateMobile: joinBaseUrl('/org/user/user/updateMobile'),
      queryMySysTheme: joinBaseUrl('/org/user/user/queryMySysTheme'),
      setMySysTheme: joinBaseUrl('/org/user/user/setMySysTheme'),
      queryMySysLanguage: joinBaseUrl('/org/user/user/queryMySysLanguage'),
      setMySysLanguage: joinBaseUrl('/org/user/user/setMySysLanguage'),
      queryOrgInvite: joinBaseUrl('/org/user/org/queryOrgInvite'),
      refreshOrgInvite: joinBaseUrl('/org/user/org/refreshOrgInvite'),
      queryOrgInfo: joinBaseUrl('/org/user/org/queryOrgInfo'),
      queryMyDepTree: joinBaseUrl('/org/user/contact/queryMyDepTree'),
      queryEmpNotDepList: joinBaseUrl('/org/user/contact/queryEmpNotDepList'),
      queryDepListByKey: joinBaseUrl('/org/user/contact/queryDepListByKey'),
      queryEmpMainDep: joinBaseUrl('/org/user/emp/queryEmpMainDep'),
      queryEmpListByKey: joinBaseUrl('/org/user/emp/queryEmpListByKey'),
      queryEmpAAS: joinBaseUrl('/org/user/emp/queryEmpAAS'),
      editEmpAAS: joinBaseUrl('/org/user/emp/editEmpAAS'),
      queryCustomStatusList:joinBaseUrl('/org/user/emp/queryCustomStatusList'),
      addCustomStatus:joinBaseUrl('/org/user/emp/addCustomStatus'),
      deleteCustomStatusById:joinBaseUrl('/org/user/emp/deleteCustomStatusById'),
      updateCustomStatusById:joinBaseUrl('/org/user/emp/updateCustomStatusById'),
      queryPostGroupTree: joinBaseUrl('/org/user/post/queryPostGroupTree'),
      queryPostByCond: joinBaseUrl('/org/user/post/queryPostByCond'),
      queryRankGroupTree: joinBaseUrl('/org/user/rank/queryRankGroupTree'),
      queryRankByCond: joinBaseUrl('/org/user/rank/queryRankByCond'),
      notTips: joinBaseUrl('/org/user/user/notTips'),
      queryExternalEmpGroupList: joinBaseUrl('/org/user/externalEmpGroup/queryExternalEmpGroupList'),
      queryExternalEmpList: joinBaseUrl('/org/user/externalEmp/queryExternalEmpList'),
      logout: joinBaseUrl('/org/user/user/logout'),
    },
    postMgt: {
      queryPostUpDownTree: joinBaseUrl('/org/mgt/postMgt/queryPostUpDownTree'),
      addPost: joinBaseUrl('/org/mgt/postMgt/addPost'),
      updatePost: joinBaseUrl('/org/mgt/postMgt/updatePost'),
      delPost: joinBaseUrl('/org/mgt/postMgt/delPost'),
      movePost: joinBaseUrl('/org/mgt/postMgt/movePost'),
      addEmpPost: joinBaseUrl('/org/mgt/postMgt/addEmpPost'),
      delEmpPost: joinBaseUrl('/org/mgt/postMgt/delEmpPost'),
      queryPostEmpPage: joinBaseUrl('/org/mgt/postMgt/queryPostEmpPage'),
    },
    rankMgt: {
      queryRankGroupList: joinBaseUrl('/org/mgt/rankMgt/queryRankGroupList'),
      addRankGroup: joinBaseUrl('/org/mgt/rankMgt/addRankGroup'),
      updateRankGroup: joinBaseUrl('/org/mgt/rankMgt/updateRankGroup'),
      delRankGroup: joinBaseUrl('/org/mgt/rankMgt/delRankGroup'),
      queryRankPageByGroup: joinBaseUrl('/org/mgt/rankMgt/queryRankPageByGroup'),
      addRank: joinBaseUrl('/org/mgt/rankMgt/addRank'),
      upateRank: joinBaseUrl('/org/mgt/rankMgt/upateRank'),
      delRank: joinBaseUrl('/org/mgt/rankMgt/delRank'),
      addRankEmp: joinBaseUrl('/org/mgt/rankMgt/addRankEmp'),
      delRankEmp: joinBaseUrl('/org/mgt/rankMgt/delRankEmp'),
      queryEmpsByRank: joinBaseUrl('/org/mgt/rankMgt/queryEmpsByRank'),
    },
    appLog: {
      queryLogPageByCond: joinBaseUrl('/portal/appLog/appLog/queryLogPageByCond'),
      queryRowDataLogPageByCond: joinBaseUrl('/portal/appLog/appLog/queryRowDataLogPageByCond'),
      queryTblDataLogPageByCond: joinBaseUrl('/portal/appLog/appLog/queryTblDataLogPageByCond'),
    },
    loginLog: {
      queryLoginLogPageByCond: joinBaseUrl('/org/mgt/loginLog/queryLoginLogPageByCond'),
    },
    orgSet: {
      queryOrgInfo: joinBaseUrl('/org/mgt/orgSet/queryOrgInfo'),
      updateOrgInfo: joinBaseUrl('/org/mgt/orgSet/updateOrgInfo'),
      queryEmpPageByCondFields: joinBaseUrl('/portal/workTbl/syncOrgToWorkTable/db/queryEmpPageByCondFields'),
      getEmpFieldList:joinBaseUrl('/portal/workTbl/syncOrg/config/getEmpFieldList'),
    },
    orgAuth: {
        queryOrgRoleList: joinBaseUrl('/org/mgt/roleMgt/queryOrgRoleList'),
        addOrgRole: joinBaseUrl('/org/mgt/roleMgt/addOrgRole'),
        updateOrgRole: joinBaseUrl('/org/mgt/roleMgt/updateOrgRole'),
        delOrgRole: joinBaseUrl('/org/mgt/roleMgt/delOrgRole'),
        queryOrgRoleMemList: joinBaseUrl('/org/mgt/roleMgt/queryOrgRoleMemList'),
        addOrgRoleMem: joinBaseUrl('/org/mgt/roleMgt/addOrgRoleMem'),
        delOrgRoleMem: joinBaseUrl('/org/mgt/roleMgt/delOrgRoleMem'),
        isOpenProduct: joinBaseUrl('/subscribe/version/ver/orgVer/isOpenProduct'),
    },
    appSet: {
        importSolutionFromFile: joinBaseUrl('/portal/appImport/appImport/importSolutionFromFile'),
        exportSolutionToFile: joinBaseUrl('/portal/appExport/appExport/exportSolutionToFile'),
        getSolutionFile: joinBaseUrl('/portal/appExport/appExport/getSolutionFile'),
    },
    report:{
        addReportRelationType: joinBaseUrl('/org/mgt/reportRelationMgt/addReportRelationType'),
        editReportRelationType: joinBaseUrl('/org/mgt/reportRelationMgt/editReportRelationType'),
        delReportRelationType: joinBaseUrl('/org/mgt/reportRelationMgt/delReportRelationType'),
        queryReportRelationTypeList: joinBaseUrl('/org/mgt/reportRelationMgt/queryReportRelationTypeList'),
        setEmpReportRelationSuper: joinBaseUrl('/org/mgt/reportRelationMgt/setEmpReportRelationSuper'),
        queryEmpReportUpDownTree: joinBaseUrl('/org/mgt/reportRelationMgt/queryEmpReportUpDownTree'),
        setEmpDown: joinBaseUrl('/org/mgt/empMgt/setEmpDown'),
        setEmpReportRelationDown: joinBaseUrl('/org/mgt/reportRelationMgt/setEmpReportRelationDown'),
        queryEmpSuperReportRelation: joinBaseUrl('/org/mgt/reportRelationMgt/queryEmpSuperReportRelation'),
    }
  },
  sysmgt: {
    mail: {
      queryMailConfig: joinBaseUrl('/svr/mail/manager/mailConfig/queryMailConfig'),
      saveMailConfig: joinBaseUrl('/svr/mail/manager/mailConfig/saveMailConfig'),
    },
    sms: {
      querySmsConfig: joinBaseUrl('/svr/sms/smsConfig/querySmsConfig'),
      saveSmsConfig: joinBaseUrl('/svr/sms/smsConfig/saveSmsConfig'),
    },
    oss: {
      queryStorageConfig: joinBaseUrl('/storage/config/queryStorageConfig'),
      saveStorageConfig: joinBaseUrl('/storage/config/saveStorageConfig'),
    }
  },
  flow:{
    queryExaminePath: joinBaseUrl('/bpm/workbentch/dtl/flowDtl/queryExaminePath'),
    queryFlowStatistics: joinBaseUrl('/bpm/flowMgt/flowMgt/queryFlowStatistics'),
    queryFlowCharts: joinBaseUrl('/bpm/flowMgt/flowMonitor/queryFlowCharts'),
    statisticsToDoQuantity: joinBaseUrl('/bpm/flowMgt/flowMonitor/statisticsToDoQuantity'),
    queryFlowInsPageByCond: joinBaseUrl('/bpm/flowMgt/flowMonitor/queryFlowInsPageByCond'),
    queryMyPenddingFlowGroup: joinBaseUrl('/bpm/workbentch/myPendding/queryMyPenddingFlowGroup'),
    queryMyExamPendByCond: joinBaseUrl('/bpm/workbentch/myPendding/queryMyExamPendByCond'),
    queryMyDealPendFlowGroup: joinBaseUrl('/bpm/workbentch/myPendding/queryMyDealPendFlowGroup'),
    queryMyDealPend: joinBaseUrl('/bpm/workbentch/myPendding/queryMyDealPend'),
    queryMyCcPendFlowGroup: joinBaseUrl('/bpm/workbentch/myPendding/queryMyCcPendFlowGroup'),
    queryMyCcPend: joinBaseUrl('/bpm/workbentch/myPendding/queryMyCcPend'),
    queryMyCrtPendFlowGroup: joinBaseUrl('/bpm/workbentch/myPendding/queryMyCrtPendFlowGroup'),
    queryMyCrtPend: joinBaseUrl('/bpm/workbentch/myPendding/queryMyCrtPend'),
    queryRunningFlowGroup: joinBaseUrl('/bpm/flowMgt/flowMonitor/queryRunningFlowGroup'),
    queryRelateBpaInfo: joinBaseUrl('/bpm/workbentch/dtl/flowDtl/queryRelateBpaInfo'),
    queryExaminAndDealFnsByFdId: joinBaseUrl('/bpm/workbentch/dtl/flowDtl/queryExaminAndDealFnsByFdId'),
    addHandSign: joinBaseUrl('/bpm/workbentch/handSign/addHandSign'),
    editHandSign: joinBaseUrl('/bpm/workbentch/handSign/editHandSign'),
    delHandSign: joinBaseUrl('/bpm/workbentch/handSign/delHandSign'),
    queryHandSignList: joinBaseUrl('/bpm/workbentch/handSign/queryHandSignList'),

    queryMyPenddingTable: joinBaseUrl('/bpm/workbentch/myPendding/queryMyPenddingTable'),
    queryMyPendRowSanList: joinBaseUrl('/bpm/workbentch/myPendding/queryMyPendRowSanList'),
    updateTaskChargeInfo: joinBaseUrl('/bpm/flowMgt/flowMgt/updateTaskChargeInfo'),
    doneExamineTask: joinBaseUrl('/bpm/flowMgt/flowMgt/doneExamineTask'),
    doneDealTask: joinBaseUrl('/bpm/flowMgt/flowMgt/doneDealTask'),
    readMyCcFlow: joinBaseUrl('/bpm/workbentch/dtl/flowDtl/readMyCcFlow'),
    saveTaskExtraData: joinBaseUrl('/bpm/workbentch/dtl/flowTaskOp/saveTaskExtraData'),
    queryTaskById: joinBaseUrl('/bpm/workbentch/dtl/flowTaskOp/queryTaskById'),
    queryDealerByFiId: joinBaseUrl('/bpm/workbentch/dtl/flowDtl/queryDealerByFiId'),
    queryFreeExamineNodes: joinBaseUrl('/bpm/workbentch/dtl/flowDtl/queryFreeExamineNodes'),
    saveFreeExamineDealers: joinBaseUrl('/bpm/workbentch/dtl/flowDtl/saveFreeExamineDealers'),
    generateFlowId: joinBaseUrl('/portal/workTbl/detail/generateFlowId'),

  },
  bpm: {
    testApi: joinBaseUrl('/bpm/def/flowNodeTest/testApi'),
    testModel:joinBaseUrl('/bpm/def/flowNodeTest/testModel'),
    testCode: joinBaseUrl('/bpm/def/flowNodeTest/testCode'),
    startFlowDebug: joinBaseUrl('/bpm/def/debug/startFlowDebug'),
    batchTerminalFlowlns: joinBaseUrl('/bpm/flowMgt/flowMonitor/batchTerminalFlowlns'),
    queryICanStartFlows: joinBaseUrl('/bpm/workbentch/iCanStart/queryICanStartFlows'),
    webhook: {
      getWhCode: joinBaseUrl('/bpm/outter/webhook/getWhCode'),
      dealWebhook: joinBaseUrl('/pub/bpm/webhook/dealWebhook/form/'),
      dealWebhookjson: joinBaseUrl('/pub/bpm/webhook/dealWebhook/json/'),
    },
    flowSmsTpl: {
      createSmsTpl: joinBaseUrl('/bpm/def/flowSmsTpl/createSmsTpl'),
      querySmsTpls: joinBaseUrl('/bpm/def/flowSmsTpl/querySmsTpls'),
      querySmsTplDtl: joinBaseUrl('/bpm/def/flowSmsTpl/querySmsTplDtl'),
    },
    flowDef: {
      createFlowDef: joinBaseUrl('/bpm/def/flowDef/createFlowDef'),
      updateFlowDef: joinBaseUrl('/bpm/def/flowDef/updateFlowDef'),
      queryDefPageByCond: joinBaseUrl('/bpm/def/flowDef/queryDefPageByCond'),
      queryFlowDefDtl: joinBaseUrl('/bpm/def/flowDef/queryFlowDefDtl'),
      startupDef: joinBaseUrl('/bpm/def/flowDef/startupDef'),
      stopDef: joinBaseUrl('/bpm/def/flowDef/stopDef'),
      delDef: joinBaseUrl('/bpm/def/flowDef/delDef'),
      updateFlowSet: joinBaseUrl('/bpm/def/flowDef/updateFlowSet'),
      queryTriggerSet: joinBaseUrl('/bpm/def/flowDef/queryTriggerSet'),
      saveFuncReturnValueSet: joinBaseUrl('/bpm/def/flowVer/saveFuncReturnValueSet'),
      queryFuncReturnValueSet: joinBaseUrl('/bpm/def/flowVer/queryFuncReturnValueSet'),
      copyFlowDef: joinBaseUrl('/bpm/def/flowDef/copyFlowDef'),
    },
    flowVer: {
      startupFv: joinBaseUrl('/bpm/def/flowVer/startupFv'),
      queryAllByFd: joinBaseUrl('/bpm/def/flowVer/queryAllByFd'),
      addFv: joinBaseUrl('/bpm/def/flowVer/addFv'),
      delFv: joinBaseUrl('/bpm/def/flowVer/delFv'),
      copyFv: joinBaseUrl('/bpm/def/flowVer/copyFv'),
    },
    flowGraph: {
      queryFlowGraph: joinBaseUrl('/bpm/def/flowGraph/queryFlowGraph'),
      addNode: joinBaseUrl('/bpm/def/flowGraph/addNode'),
      delNode: joinBaseUrl('/bpm/def/flowGraph/delNode'),
      saveNodeSet: joinBaseUrl('/bpm/def/flowGraph/saveNodeSet'),
      addBranchNode: joinBaseUrl('/bpm/def/flowGraph/addBranchNode'),
      addBranch: joinBaseUrl('/bpm/def/flowGraph/addBranch'),
      delBranch: joinBaseUrl('/bpm/def/flowGraph/delBranch'),
      setBranchCond: joinBaseUrl('/bpm/def/flowGraph/setBranchCond'),
      addLoopNode: joinBaseUrl('/bpm/def/flowGraph/addLoopNode'),
      delLoopNode: joinBaseUrl('/bpm/def/flowGraph/delLoopNode'),
      addInlineSubNode: joinBaseUrl('/bpm/def/flowGraph/addInlineSubNode'),
      delInlineSubNode: joinBaseUrl('/bpm/def/flowGraph/delInlineSubNode'),
    },
    flowDs: {
      queryFlowDs: joinBaseUrl('/bpm/def/flowDs/queryFlowDs'),
      queryAuditDs: joinBaseUrl('/bpm/def/flowDs/queryAuditDs'),
    },
    workbentch: {
      myPendding: {
        queryMyExamPend: joinBaseUrl('/bpm/workbentch/myPendding/queryMyExamPend'),
        queryMyTimeoutPend: joinBaseUrl('/bpm/workbentch/myPendding/queryMyTimeoutPend'),
        queryMyAboutTimeoutPend: joinBaseUrl('/bpm/workbentch/myPendding/queryMyAboutTimeoutPend'),
        queryMyUrgePend: joinBaseUrl('/bpm/workbentch/myPendding/queryMyUrgePend'),
        queryTimeoutPendNum: joinBaseUrl('/bpm/workbentch/myPendding/queryTimeoutPendNum'),
        queryMyDealPend: joinBaseUrl('/bpm/workbentch/myPendding/queryMyDealPend'),
        queryMyCcPend: joinBaseUrl('/bpm/workbentch/myPendding/queryMyCcPend'),
        queryMyCrtPend: joinBaseUrl('/bpm/workbentch/myPendding/queryMyCrtPend'),
        queryPendingNum: joinBaseUrl('/bpm/workbentch/myPendding/queryPendingNum'),
      },
      myComplete: {
        queryMyExamFinishFlowGroup: joinBaseUrl('/bpm/workbentch/myComplete/queryMyExamFinishFlowGroup'),
        queryMyDealFinishFlowGroup: joinBaseUrl('/bpm/workbentch/myComplete/queryMyDealFinishFlowGroup'),
        queryMyCcFinishFlowGroup: joinBaseUrl('/bpm/workbentch/myComplete/queryMyCcFinishFlowGroup'),
        queryMyCrtFinishFlowGroup: joinBaseUrl('/bpm/workbentch/myComplete/queryMyCrtFinishFlowGroup'),
        queryMyExamFinish: joinBaseUrl('/bpm/workbentch/myComplete/queryMyExamFinish'),
        queryMyCrtFinish: joinBaseUrl('/bpm/workbentch/myComplete/queryMyCrtFinish'),
        queryMyCcFinish: joinBaseUrl('/bpm/workbentch/myComplete/queryMyCcFinish'),
        queryMyDealFinish: joinBaseUrl('/bpm/workbentch/myComplete/queryMyDealFinish'),
      },
      oftenSuggest: {
        queryOsPage: joinBaseUrl('/bpm/workbentch/oftenSuggest/queryOsPage'),
        queryMyOs: joinBaseUrl('/bpm/workbentch/oftenSuggest/queryMyOs'),
        addOs: joinBaseUrl('/bpm/workbentch/oftenSuggest/addOs'),
        updateOs: joinBaseUrl('/bpm/workbentch/oftenSuggest/updateOs'),
        delOs: joinBaseUrl('/bpm/workbentch/oftenSuggest/delOs'),
      },
      agency: {
        addAgency: joinBaseUrl('/bpm/workbentch/agency/addAgency'),
        editAgency: joinBaseUrl('/bpm/workbentch/agency/editAgency'),
        delAgency: joinBaseUrl('/bpm/workbentch/agency/delAgency'),
        queryMyAgencyPage: joinBaseUrl('/bpm/workbentch/agency/queryMyAgencyPage'),
        queryToMeAgencyPage: joinBaseUrl('/bpm/workbentch/agency/queryToMeAgencyPage'),
      },
      dtl: {
        invokerFlowDtl: joinBaseUrl('/bpm/workbentch/dtl/flowDtl/invokerFlowDtl'),
        queryExecutePath: joinBaseUrl('/bpm/workbentch/dtl/flowDtl/queryExecutePath'),
        queryTblFlowPath: joinBaseUrl('/bpm/workbentch/dtl/flowDtl/queryTblFlowPath'),
        pass: joinBaseUrl('/bpm/workbentch/dtl/flowTaskOp/pass'),
        rejectSign: joinBaseUrl('/bpm/workbentch/dtl/flowTaskOp/rejectSign'),
        refuse: joinBaseUrl('/bpm/workbentch/dtl/flowTaskOp/refuse'),
        backToCreator: joinBaseUrl('/bpm/workbentch/dtl/flowTaskOp/backToCreator'),
        createdeal: joinBaseUrl('/bpm/workbentch/dtl/flowTaskOp/createdeal'),
        deal: joinBaseUrl('/bpm/workbentch/dtl/flowTaskOp/deal'),
        add: joinBaseUrl('/bpm/workbentch/dtl/flowTaskOp/add'),
        transfer: joinBaseUrl('/bpm/workbentch/dtl/flowTaskOp/transfer'),
        backTo: joinBaseUrl('/bpm/workbentch/dtl/flowTaskOp/backTo'),
        queryFlowBackNodes: joinBaseUrl('/bpm/workbentch/dtl/flowDtl/queryFlowBackNodes'),
        revoke: joinBaseUrl('/bpm/workbentch/dtl/flowTaskOp/revoke'),
        revokedeal: joinBaseUrl('/bpm/workbentch/dtl/flowTaskOp/revokedeal'),
        urge: joinBaseUrl('/bpm/workbentch/dtl/flowTaskOp/urge'),
        queryUrgeLogList: joinBaseUrl('/bpm/workbentch/dtl/flowDtl/queryUrgeLogList'),
        rescind: joinBaseUrl('/bpm/workbentch/dtl/flowTaskOp/rescind'),
      },
    },
    flowMgt: {
      queryFlowDefPageByCond: joinBaseUrl('/bpm/flowMgt/flowMgt/queryFlowDefPageByCond'),
      queryFiPageByDef: joinBaseUrl('/bpm/flowMgt/flowMgt/queryFiPageByDef'),
      queryFlowPathByFi: joinBaseUrl('/bpm/flowMgt/flowMgt/queryFlowPathByFi'),
      queryFlowTaskPageByCond: joinBaseUrl('/bpm/flowMgt/flowMonitor/queryFlowTaskPageByCond'),
      queryCompleteFlowInsPageByCond: joinBaseUrl('/bpm/flowMgt/flowMonitor/queryCompleteFlowInsPageByCond'),
      terminalFlowlns: joinBaseUrl('/bpm/flowMgt/flowMonitor/terminalFlowlns'),
    }
  },
  typeApi: {
    add: joinBaseUrl('/pub/portal/openplat/api/tbl/addRowData'),
    update: joinBaseUrl('/pub/portal/openplat/api/tbl/editRowData'),
    del: joinBaseUrl('/pub/portal/openplat/api/tbl/delRowData'),
    query: joinBaseUrl('/pub/portal/openplat/api/tbl/getRowData'),
    contrast: joinBaseUrl('/pub/portal/app/appPubApi/contrast'),
    getWtDataPage: joinBaseUrl('/pub/portal/openplat/api/tbl/getWtDataPage'),
    addOrUpdateByFilter: joinBaseUrl('/pub/portal/openplat/api/tbl/addOrUpdateByFilter'),
  },
  etl: {
    connect: {
      addConnect: joinBaseUrl('/etl/connect/connect/addConnect'),
      delConnect: joinBaseUrl('/etl/connect/connect/delConnect'),
      updateConnect: joinBaseUrl('/etl/connect/connect/updateConnect'),
      queryConnectList: joinBaseUrl('/etl/connect/connect/queryConnectList'),
    },
    def: {
      queryEtlDefPage: joinBaseUrl('/etl/def/etlDef/queryEtlDefPage'),
      addEtlDef: joinBaseUrl('/etl/def/etlDef/addEtlDef'),
      delEtlDef: joinBaseUrl('/etl/def/etlDef/delEtlDef'),
      queryEtlGraph: joinBaseUrl('/etl/def/etlGraph/queryEtlGraph'),
      addStep: joinBaseUrl('/etl/def/etlGraph/addStep'),
      delStep: joinBaseUrl('/etl/def/etlGraph/delStep'),
      queryEtlVerList: joinBaseUrl('/etl/def/etlVer/queryEtlVerList'),
      copyEtlVer: joinBaseUrl('/etl/def/etlVer/copyEtlVer'),
      delEtlVer: joinBaseUrl('/etl/def/etlVer/delEtlVer'),
      startEtlVer: joinBaseUrl('/etl/def/etlVer/startEtlVer'),
    }
  },
  integrate: {
    connector: {
      addConnect: joinBaseUrl('/integrate/connector/connector/addCnt'),
      updateCnt: joinBaseUrl('/integrate/connector/connector/updateCnt'),
      delCnt: joinBaseUrl('/integrate/connector/connector/delCnt'),
      queryCntPageByCond: joinBaseUrl('/integrate/connector/connector/queryCntPageByCond'),
      addCntApi: joinBaseUrl('/integrate/connector/connectorApi/addCntApi'),
      updateCntApi: joinBaseUrl('/integrate/connector/connectorApi/updateCntApi'),
      delCntApi: joinBaseUrl('/integrate/connector/connectorApi/delCntApi'),
      queryCntApiList: joinBaseUrl('/integrate/connector/connectorApi/queryCntApiList'),
      genSign: joinBaseUrl('/integrate/connector/connectorApi/genSign'),
      changeConnectorState: joinBaseUrl('/integrate/connector/connector/changeConnectorState'),
      testOp: joinBaseUrl('/integrate/connector/connectorApi/testOp'),
      queryOpendCntList: joinBaseUrl('/integrate/connector/connectorUse/queryOpendCntList'),
      queryOpenApiListByCnt: joinBaseUrl('/integrate/connector/connectorUse/queryOpenApiListByCnt'),
      queryAllSupplier: joinBaseUrl('/pub/integrate/connector/tpl/tplView/queryAllSupplier'),
      queryAllFuncGroup: joinBaseUrl('/pub/integrate/connector/tpl/tplView/queryAllFuncGroup'),
      installConnectorTpl: joinBaseUrl('/integrate/connector/tpl/tplView/installConnectorTpl'),
      tpl: {
        queryPageByCond: joinBaseUrl('/pub/integrate/connector/tpl/tplView/queryPageByCond'),
        queryConnectorDtl: joinBaseUrl('/pub/integrate/connector/tpl/tplView/queryConnectorDtl'),
      }
    },
    qywx: {
      queryConfig: joinBaseUrl('/integrate/qywx/qywxConfig/queryConfig'),
      saveConfig: joinBaseUrl('/integrate/qywx/qywxConfig/saveConfig'),
      saveInstallConfig: joinBaseUrl('/integrate/qywx/qywxConfig/saveInstallConfig'),
      queryInstallConfig: joinBaseUrl('/integrate/qywx/qywxConfig/queryInstallConfig'),
    },
    dingtalk: {
      queryConfig: joinBaseUrl('/integrate/dingtalk/dingtalkConfig/queryConfig'),
      saveConfig: joinBaseUrl('/integrate/dingtalk/dingtalkConfig/saveConfig'),
    }
  },
  tpl:{
      queryRecommendPage:joinBaseUrl('/pub/portal/apptpl/appTpl/queryRecommendPage'),
      queryDtlById:joinBaseUrl('/pub/portal/apptpl/appTpl/queryDtlById'),
      queryPageByCond:joinBaseUrl('/pub/portal/apptpl/appTpl/queryPageByCond'),
      install:joinBaseUrl('/portal/apptpl/appTplInstall/install'),
},
  im: {
    
    queryMyTalkPage: joinBaseUrl('/im/talk/talk/queryMyTalkPage'),
    queryMsgByTalkPage: joinBaseUrl('/im/talk/talk/queryMsgByTalkPage'),
    queryNoticeSet: joinBaseUrl('/im/talk/noticeSetMgt/queryNoticeSet'),
    updateNoticeSet: joinBaseUrl('/im/talk/noticeSetMgt/updateNoticeSet'),

    imWebsocket: joinWebsockUrl('/pub/im/imWebsocket'),
    pullOfflineMsg: joinBaseUrl('/im/msg/offlineMsg/'),
    pullOfflineMsgByTalk: joinImBaseUrl('/im/msg/offlineMsg/pullOfflineMsgByTalk'),
    
    delOfflinMsg: joinBaseUrl('/im/msg/offlineMsg/delOfflinMsg'),
    crtImGroup: joinBaseUrl('/im/biz/imGroup/crtImGroup'),
    delImGroup: joinBaseUrl('/im/biz/imGroup/delImGroup'),
    editImGroup: joinBaseUrl('/im/biz/imGroup/editImGroup'),
    queryImGroupDtl: joinBaseUrl('/im/biz/imGroup/queryImGroupDtl'),
    queryMyImGroupList: joinBaseUrl('/im/biz/imGroup/queryMyImGroupList'),
    queryGroupMemListByGroupId: joinBaseUrl('/im/biz/imGroup/queryGroupMemListByGroupId'),
    batchAddGroupMem: joinBaseUrl('/im/biz/imGroup/batchAddGroupMem'),
    batchDelGroupMem: joinBaseUrl('/im/biz/imGroup/batchDelGroupMem'),
    exitImGroup: joinBaseUrl('/im/biz/imGroup/exitImGroup'),
    transferImGroupOwner: joinBaseUrl('/im/biz/imGroup/transferImGroupOwner'),
    queryMyTaskStatus: joinBaseUrl('/bpm/workbentch/dtl/flowTaskOp/queryMyTaskStatus'),
    uploadMsgImage: joinBaseUrl('/im/msg/msgImage/uploadMsgImage'),
    editGroupMemMgtStatus: joinBaseUrl('/im/biz/imGroup/editGroupMemMgtStatus'),
    queryMyEmpDtl: joinBaseUrl('/org/user/contact/queryEmpDtl'),
    isGroupMgt: joinBaseUrl('/im/biz/imGroup/isGroupMgt'),
  },
  license: {
    queryMachineCode: joinBaseUrl('/pub/license/cst/license/queryMachineCode'),
    saveLicense: joinBaseUrl('/pub/license/cst/license/saveLicense'),
    isLicenseCorrect: joinBaseUrl('/pub/license/cst/license/isLicenseCorrect'),
    queryAllLicense: joinBaseUrl('/license/cst/licenseMgt/queryAllLicense'),
    changeLicense: joinBaseUrl('/license/cst/license/changeLicense'),
    isExistOrg: joinBaseUrl('/pub/org/user/pub/isExistOrg'),
    regOrgFromPri: joinBaseUrl('/pub/org/user/pub/regOrgFromPri'),
    setApiDomain: joinBaseUrl('/pub/license/cst/license/setApiDomain'),
  },
  comment: {
    queryReplyPage: joinBaseUrl('/common/comment/user/queryReplyPage'),
    addReply: joinBaseUrl('/common/comment/user/addReply'),
    delMyReply: joinBaseUrl('/common/comment/user/delMyReply'),
    queryCommentById: joinBaseUrl('/common/comment/user/queryCommentById'),
    addComment: joinBaseUrl('/common/comment/user/addComment'),
    delMyComment: joinBaseUrl('/common/comment/user/delMyComment'),
  },
  subscribe: {
    queryOrgVerAndUsage: joinBaseUrl('/subscribe/version/ver/orgVer/queryOrgVerAndUsage'),
  },
  openplat: {
    queryKeyAndSecret: joinBaseUrl('/openplat/appkey/appkey/queryKeyAndSecret'),
    resetSecret: joinBaseUrl('/openplat/appkey/appkey/resetSecret'),
  },
  know:{
    addKnRepGroup: joinBaseUrl('/know/knRep/knRepGroup/addKnRepGroup'),
    editKnRepGroup: joinBaseUrl('/know/knRep/knRepGroup/editKnRepGroup'),
    queryKnRepGroupList: joinBaseUrl('/know/knRep/knRepGroup/queryKnRepGroupList'),
    delKnRepGroup: joinBaseUrl('/know/knRep/knRepGroup/delKnRepGroup'),
    queryKpAccessLog: joinBaseUrl('/know/knPage/kpAccessLog/queryKpAccessLog'),
    queryAccessLogOverView: joinBaseUrl('/know/knPage/kpAccessLog/queryAccessLogOverView'),
    downKpFileLog: joinBaseUrl('/know/knPage/kpAccessLog/downKpFileLog'),
    queryKnRepsByKrgId: joinBaseUrl('/know/knRep/knRep/queryKnRepsByKrgId'),
    queryKnRepGroupDtl: joinBaseUrl('/know/knRep/knRepGroup/queryKnRepGroupDtl'),
    addKnRep: joinBaseUrl('/know/knRep/knRep/addKnRep'),
    queryKnRepsByKey: joinBaseUrl('/know/knRep/knRep/queryKnRepsByKey'),
    queryAllFks: joinBaseUrl('/know/knPage/favoriteKp/queryAllFks'),
    queryAllStarKnReps: joinBaseUrl('/know/knRep/starknRep/queryAllStarKnReps'),
    queryAllKnPageByKrId: joinBaseUrl('/know/knPage/knPage/queryAllKnPageByKrId'),
    queryKnRepDtl: joinBaseUrl('/know/knRep/knRep/queryKnRepDtl'),
    addStarKnRep: joinBaseUrl('/know/knRep/starknRep/addStarKnRep'),
    cancelStarKnRep: joinBaseUrl('/know/knRep/starknRep/cancelStarKnRep'),
    editKnRep: joinBaseUrl('/know/knRep/knRep/editKnRep'),
    delKnRep: joinBaseUrl('/know/knRep/knRep/delKnRep'),
    addFavoriteKp: joinBaseUrl('/know/knPage/favoriteKp/addFavoriteKp'),
    cancelFavoriteKp: joinBaseUrl('/know/knPage/favoriteKp/cancelFavoriteKp'),
    addKnPage: joinBaseUrl('/know/knPage/knPage/addKnPage'),
    editKnPage: joinBaseUrl('/know/knPage/knPage/editKnPage'),
    delKnPage: joinBaseUrl('/know/knPage/knPage/delKnPage'),
    queryKnPageById: joinBaseUrl('/know/knPage/knPage/queryKnPageById'),
    editKnRepStatus: joinBaseUrl('/know/knRep/knRep/editKnRepStatus'),
    editKnPageStatus: joinBaseUrl('/know/knPage/knPage/editKnPageStatus'),
    queryRecycleKnPageByKrId: joinBaseUrl('/know/knPage/knPage/queryRecycleKnPageByKrId'),
    queryMyCreateKpList: joinBaseUrl('/know/knPage/knPage/queryMyCreateKpList'),

    queryAllKnRoles: joinBaseUrl('/know/knAuth/knRole/queryAllKnRoles'),
    addKnRole: joinBaseUrl('/know/knAuth/knRole/addKnRole'),
    editKnRole: joinBaseUrl('/know/knAuth/knRole/editKnRole'),
    delKnRole: joinBaseUrl('/know/knAuth/knRole/delKnRole'),
    queryAllKrMems: joinBaseUrl('/know/knAuth/knRoleMem/queryAllKrMems'),
    addKrMem: joinBaseUrl('/know/knAuth/knRoleMem/addKrMem'),
    delKrMem: joinBaseUrl('/know/knAuth/knRoleMem/delKrMem'),
    queryAllKrAuth: joinBaseUrl('/know/knAuth/knRoleAuth/queryAllKrAuth'),
    editKrAuth: joinBaseUrl('/know/knAuth/knRoleAuth/editKrAuth'),
    moveKnPage: joinBaseUrl('/know/knPage/knPage/moveKnPage'),
    queryAllKpLimits: joinBaseUrl('/know/knAuth/knPageLimit/queryAllKpLimits'),
    editKnPageWhiteStatus: joinBaseUrl('/know/knPage/knPage/editKnPageWhiteStatus'),
    updateAllKpLimits: joinBaseUrl('/know/knAuth/knPageLimit/updateAllKpLimits'),
    addKpOpHistory: joinBaseUrl('/know/knPage/kpOpHistory/addKpOpHistory'),
    queryAllKpOpHtVersions: joinBaseUrl('/know/knPage/kpOpHtVersion/queryAllKpOpHtVersions'),
    queryAllKpOpHistorysByKohId: joinBaseUrl('/know/knPage/kpOpHistory/queryAllKpOpHistorysByKohId'),
    backByKpOpHistoryToSave: joinBaseUrl('/know/knPage/kpOpHtVersion/backByKpOpHistoryToSave'),
    backByKpOpHistory: joinBaseUrl('/know/knPage/kpOpHtVersion/backByKpOpHistory'),
    adjustSeq: joinBaseUrl('/know/knPage/knPage/adjustSeq'),
    contentLucene: joinBaseUrl('/know/knPage/knPage/contentLucene'),
    addFileVer: joinBaseUrl('/know/knPage/fileVer/addFileVer'),
    queryKnowFileVerList: joinBaseUrl('/know/knPage/fileVer/queryKnowFileVerList'),
    backKnowFileVer: joinBaseUrl('/know/knPage/fileVer/backKnowFileVer'),
    queryCurKrAuth: joinBaseUrl('/know/knRep/knRep/queryCurKrAuth'),
    queryKpTree: joinBaseUrl('/portal/workTbl/knowOperate/queryKpTree'),

    queryPpgTree: joinBaseUrl('/know/personal/personalPageGroup/queryPpgTree'),
    addPpg: joinBaseUrl('/know/personal/personalPageGroup/addPpg'),
    editPpg: joinBaseUrl('/know/personal/personalPageGroup/editPpg'),
    delPpg: joinBaseUrl('/know/personal/personalPageGroup/delPpg'),
    movePpg: joinBaseUrl('/know/personal/personalPageGroup/movePpg'),
    addPersonalPage: joinBaseUrl('/know/personal/personalPage/addPersonalPage'),
    editPersonalPage: joinBaseUrl('/know/personal/personalPage/editPersonalPage'),
    editPersonalPageContent: joinBaseUrl('/know/personal/personalPage/editPersonalPageContent'),
    delPersonalPage: joinBaseUrl('/know/personal/personalPage/delPersonalPage'),
    queryPersonalPageList: joinBaseUrl('/know/personal/personalPage/queryPersonalPageList'),
    queryPersonalPageDtl: joinBaseUrl('/know/personal/personalPage/queryPersonalPageDtl'),
    movePersonalPage: joinBaseUrl('/know/personal/personalPage/movePersonalPage'),

    addShareOrg: joinBaseUrl('/know/personal/shareOrg/addShareOrg'),
    editShareOrg: joinBaseUrl('/know/personal/shareOrg/editShareOrg'),
    delShareOrg: joinBaseUrl('/know/personal/shareOrg/delShareOrg'),
    queryShareOrgList: joinBaseUrl('/know/personal/shareOrg/queryShareOrgList'),
    openShareInternet: joinBaseUrl('/know/personal/shareInternet/openShareInternet'),
    closeShareInternet: joinBaseUrl('/know/personal/shareInternet/closeShareInternet'),
    editShareInternet: joinBaseUrl('/know/personal/shareInternet/editShareInternet'),
    queryShareInternet: joinBaseUrl('/know/personal/shareInternet/queryShareInternet'),
    queryPubPersonalPageDtl: joinBaseUrl('/pub/know/personal/shareCode/queryPersonalPageDtl'),
    editPubPersonalPage: joinBaseUrl('/pub/know/personal/shareCode/editPersonalPage'),
    queryMyShare: joinBaseUrl('/know/personal/pageShare/queryMyShare'),
    queryShareToMe: joinBaseUrl('/know/personal/pageShare/queryShareToMe'),
    queryPageAuthByPpId: joinBaseUrl('/know/personal/personalPage/queryPageAuthByPpId'),
    queryPageAuthByCode: joinBaseUrl('/pub/know/personal/shareCode/queryPageAuthByCode'),
    getFileByCode: joinBaseUrl('/pub/know/personal/shareCode/getFileByCode'),
    queryLastUpdatePpList: joinBaseUrl('/know/personal/personalPage/queryLastUpdatePpList'),

    saveKnPageVer: joinBaseUrl('/know/knPage/knPageVer/saveKnPageVer'),
    delKnPageVer: joinBaseUrl('/know/knPage/knPageVer/delKnPageVer'),
    queryKnPageVerList: joinBaseUrl('/know/knPage/knPageVer/queryKnPageVerList'),
    queryKnPageVer: joinBaseUrl('/know/knPage/knPageVer/queryKnPageVer'),
    queryMyLatelyKnPage: joinBaseUrl('/know/knPage/knPage/queryMyLatelyKnPage'),

    addFacilitator: joinBaseUrl('/know/knAuth/knPageAuth/addFacilitator'),
    editFacilitator: joinBaseUrl('/know/knAuth/knPageAuth/editFacilitator'),
    delFacilitator: joinBaseUrl('/know/knAuth/knPageAuth/delFacilitator'),
    transferToOther: joinBaseUrl('/know/knAuth/knPageAuth/transferToOther'),
    queryAuthByKpId: joinBaseUrl('/know/knAuth/knPageAuth/queryAuthByKpId'),
    getMyAuthByKpId: joinBaseUrl('/know/knAuth/knPageAuth/getMyAuthByKpId'),
    
  },
  taskCenter: {
    queryMyTaskByCond: joinBaseUrl('/portal/task/taskCenter/queryMyTaskByCond'),
    queryTaskCount: joinBaseUrl('/portal/task/taskCenter/queryTaskCount'),
    addTask: joinBaseUrl('/portal/task/task/addTask'),
    updateTask: joinBaseUrl('/portal/task/task/updateTask'),
    delTask: joinBaseUrl('/portal/task/task/delTask'),
    queryTaskDtl: joinBaseUrl('/portal/task/task/queryTaskDtl'),
    completeTask: joinBaseUrl('/portal/task/task/completeTask'),
    queryMyTaskTableByCond: joinBaseUrl('/portal/task/taskCenter/queryMyTaskTableByCond'),
    queryOrgTaskByCond: joinBaseUrl('/portal/task/taskCenter/queryOrgTaskByCond'),
    queryOrgTaskTableByCond: joinBaseUrl('/portal/task/taskCenter/queryOrgTaskTableByCond'),
  },
  scheduleCenter:{
    queryCurUserCalList:joinBaseUrl('/portal/calendar/calendar/queryCurUserCalList'),
    addCalendar:joinBaseUrl('/portal/calendar/calendar/addCalendar'),
    editCalendar:joinBaseUrl('/portal/calendar/calendar/editCalendar'),
    delCalendar:joinBaseUrl('/portal/calendar/calendar/delCalendar'),
    updateCalendarEmpList:joinBaseUrl('/portal/calendar/calendarEmp/updateCalendarEmpList'),
    queryCeListByCalId:joinBaseUrl('/portal/calendar/calendarEmp/queryCeListByCalId'),
    addSchedule:joinBaseUrl('/portal/calendar/schedule/addSchedule'),
    editSchedule:joinBaseUrl('/portal/calendar/schedule/editSchedule'),
    delSchedule:joinBaseUrl('/portal/calendar/schedule/delSchedule'),
    queryScheduleDtl:joinBaseUrl('/portal/calendar/schedule/queryScheduleDtl'),
    queryScheduleList:joinBaseUrl('/portal/calendar/schedule/queryScheduleList'),
    queryCalendarDtl:joinBaseUrl('/portal/calendar/calendar/queryCalendarDtl'),
    joinChoose:joinBaseUrl('/portal/calendar/schedule/joinChoose'),
    queryMrSchList:joinBaseUrl('/portal/calendar/schedule/queryMrSchList'),
  },
  meetingroom:{
    queryMeetingRoomList:joinBaseUrl('/portal/meetingroom/meetingroom/queryMeetingRoomList'),
  },
  meetingroommgt:{
    addMeetingRoom:joinBaseUrl('/portal/meetingroom/meetingroommgt/addMeetingRoom'),
    updateMeetingRoom:joinBaseUrl('/portal/meetingroom/meetingroommgt/updateMeetingRoom'),
    delMeetingRoom:joinBaseUrl('/portal/meetingroom/meetingroommgt/delMeetingRoom'),
    queryMeetingRoomDtl:joinBaseUrl('/portal/meetingroom/meetingroommgt/queryMeetingRoomDtl'),
    queryMeetingRoomList:joinBaseUrl('/portal/meetingroom/meetingroommgt/queryMeetingRoomList'),
  },

  education:{
    // MGT
    // 题库
    addQuesBank:joinBaseUrl('/education/course/mgt/addQuesBank'),
    updateQuesBank:joinBaseUrl('/education/course/mgt/updateQuesBank'),
    queryQuesBankList:joinBaseUrl('/education/course/mgt/queryQuesBankList'),
    deleteQuesBank:joinBaseUrl('/education/course/mgt/deleteQuesBank'),

    // 题目
    addQuestion:joinBaseUrl('/education/course/mgt/addQuestion'),
    addQuestionList:joinBaseUrl('/education/course/mgt/addQuestionList'),
    queryQuestionList:joinBaseUrl('/education/course/mgt/queryQuestionList'),
    updateQuestion:joinBaseUrl('/education/course/mgt/updateQuestion'),
    deleteQuestion:joinBaseUrl('/education/course/mgt/deleteQuestion'),
    //新增查看进度
    queryCourseEmpDetailList:joinBaseUrl('/education/course/mgt/queryCourseEmpDetailList'),

    // 题库分类
    queryQuesBankTypeList:joinBaseUrl('/education/course/mgt/queryQuesBankTypeList'),
    addQuesBankType:joinBaseUrl('/education/course/mgt/addQuesBankType'),
    deleteQuesBankType:joinBaseUrl('/education/course/mgt/deleteQuesBankType'),

    // 试卷
    queryTestPaperList:joinBaseUrl('/education/examination/mgt/queryTestPaperList'),
    queryById:joinBaseUrl('/education/course/mgt/queryById'),
    addTestPaper:joinBaseUrl('/education/examination/mgt/addTestPaper'),
    updateTestPaper:joinBaseUrl('/education/examination/mgt/updateTestPaper'),
    deleteTestPaper:joinBaseUrl('/education/examination/mgt/deleteTestPaper'),
    queryTestPaperDetails:joinBaseUrl('/education/examination/mgt/queryTestPaperDetails'),

    //公开考试
    SignInExamination:joinBaseUrl('/pub/education/examination/mgt/SignInExamination'),
    queryExaminationDetailsByExamresId:joinBaseUrl('/pub/education/examination/mgt/queryExaminationDetailsByExamresId'),

    // 试卷题目
    queryTestPaperQuestioList:joinBaseUrl('/education/examination/mgt/queryTestPaperQuestioList'),
    addTestPaperQuestion:joinBaseUrl('/education/examination/mgt/addTestPaperQuestion'),
    queryTestPaperQuestionDetails:joinBaseUrl('/education/examination/mgt/queryTestPaperQuestionDetails'),
    updateTestPaperQuestion:joinBaseUrl('/education/examination/mgt/updateTestPaperQuestion'),
    deleteTestPaperQuestion:joinBaseUrl('/education/examination/mgt/deleteTestPaperQuestion'),

    // 试卷分类
    addTestPaperType:joinBaseUrl('/education/examination/mgt/addTestPaperType'),
    queryTestPaperTypeList:joinBaseUrl('/education/examination/mgt/queryTestPaperTypeList'),
    deleteTestPaperType:joinBaseUrl('/education/examination/mgt/deleteTestPaperType'),

    // 考试
    addExamination:joinBaseUrl('/education/examination/mgt/addExamination'),
    queryExaminationList:joinBaseUrl('/education/examination/mgt/queryExaminationList'),
    queryExaminationDetails:joinBaseUrl('/education/examination/mgt/queryExaminationDetails'),
    publishExamination:joinBaseUrl('/education/examination/mgt/publishExamination'),
    deleteExamination:joinBaseUrl('/education/examination/mgt/deleteExamination'),
    queryExamEmpList:joinBaseUrl('/education/examination/mgt/queryExamEmpList'),
    queryExamEmpAnswerDetails:joinBaseUrl('/education/examination/mgt/queryExamEmpAnswerDetails'),
    submitScore:joinBaseUrl('/education/examination/mgt/submitScore'),
    completeMark:joinBaseUrl('/education/examination/mgt/completeMark'),
    queryExamAnalysis:joinBaseUrl('/education/examination/mgt/queryExamAnalysis'),
    queryExamLeaderboard:joinBaseUrl('/education/examination/mgt/queryExamLeaderboard'),
    queryDepTree: joinBaseUrl('/org/mgt/depMgt/queryDepTree'),
    updateExamination: joinBaseUrl('/education/examination/mgt/updateExamination'),
    addEmpExamination: joinBaseUrl('/education/examination/mgt/addEmpExamination'),
    deleteEmpExamination: joinBaseUrl('/education/examination/mgt/deleteEmpExamination'),


    // 课程中心
    queryAllCourseList:joinBaseUrl('/education/course/emp/queryAllCourseList'),
    // 课程分类
    addCourseType:joinBaseUrl('/education/course/mgt/addCourseType'),
    queryCourseTypeList:joinBaseUrl('/education/course/mgt/queryCourseTypeList'),
    deleteCourseType:joinBaseUrl('/education/course/mgt/deleteCourseType'),

    // 课程
    addCourse:joinBaseUrl('/education/course/mgt/addCourse'),
    queryCourseList:joinBaseUrl('/education/course/mgt/queryCourseList'),
    deleteCourse:joinBaseUrl('/education/course/mgt/deleteCourse'),
    updateCourse:joinBaseUrl('/education/course/mgt/updateCourse'),
    queryCourseDetails:joinBaseUrl('/education/course/mgt/queryCourseDetails'),
    updateCourseSetting:joinBaseUrl('/education/course/mgt/updateCourseSetting'),
    updateCourseStatus:joinBaseUrl('/education/course/mgt/updateCourseStatus'),
    updateCourseWithSign:joinBaseUrl('/education/course/mgt/updateCourseWithSign'),

    //签到
    queryCourseEmpSignList:joinBaseUrl('/education/course/mgt/queryCourseEmpSignList'),
    


    // 课时
    addLesson:joinBaseUrl('/education/course/lesson/mgt/addLesson'),
    queryLessonList:joinBaseUrl('/education/course/lesson/mgt/queryLessonList'),
    deleteLesson:joinBaseUrl('/education/course/lesson/mgt/deleteLesson'),
    queryLessonDetails:joinBaseUrl('/education/course/lesson/mgt/queryLessonDetails'),
    updateLesson:joinBaseUrl('/education/course/lesson/mgt/updateLesson'),
    addLessonExercise:joinBaseUrl('/education/course/lesson/mgt/addLessonExercise'),
    queryLessonExerciseList:joinBaseUrl('/education/course/lesson/mgt/queryLessonExerciseList'),
    deleteLessonExercise:joinBaseUrl('/education/course/lesson/mgt/deleteLessonExercise'),


    // 岗位课程
    addPostCourse:joinBaseUrl('/education/course/mgt/addPostCourse'),
    queryPostCourseList:joinBaseUrl('/education/course/mgt/queryPostCourseList'),
    deletePostCourse:joinBaseUrl('/education/course/mgt/deletePostCourse'),


    // 培训计划
    // 培训分类
    addTrainType:joinBaseUrl('/education/train/mgt/addTrainType'),
    queryTrainTypeList:joinBaseUrl('/education/train/mgt/queryTrainTypeList'),
    deleteTrainType:joinBaseUrl('/education/train/mgt/deleteTrainType'),

    // 培训
    addTrain:joinBaseUrl('/education/train/mgt/addTrain'),
    queryAllTrainList:joinBaseUrl('/education/train/mgt/queryAllTrainList'),
    queryTrainList:joinBaseUrl('/education/train/mgt/queryTrainList'),
    queryTrainDetails:joinBaseUrl('/education/train/mgt/queryTrainDetails'),
    deleteTrain:joinBaseUrl('/education/train/mgt/deleteTrain'),
    updateTrain:joinBaseUrl('/education/train/mgt/updateTrain'),

    //培训人员添加
    parseTextToEmpList:joinBaseUrl('/education/train/mgt/parseTextToEmpList'), 

    // 添加/删除(课程/考试/人员)
    addTrainCourse:joinBaseUrl('/education/train/mgt/addTrainCourse'),
    delTrainCourse:joinBaseUrl('/education/train/mgt/delTrainCourse'),
    addTrainExam:joinBaseUrl('/education/train/mgt/addTrainExam'),
    delTrainExam:joinBaseUrl('/education/train/mgt/delTrainExam'),
    addTrainEmp:joinBaseUrl('/education/train/mgt/addTrainEmp'),
    delTrainEmp:joinBaseUrl('/education/train/mgt/delTrainEmp'),

    // 查询学员培训列表
    queryEmpTrainList:joinBaseUrl('/education/train/mgt/queryEmpTrainList'),
    queryEmpTrainDetails:joinBaseUrl('/education/train/mgt/queryEmpTrainDetails'),
    queryTrainStatisticalAnalysis:joinBaseUrl('/education/train/mgt/queryTrainStatisticalAnalysis'),

    //证书
    addCertemplate:joinBaseUrl('/education/train/mgt/addCertemplate'),
    deleteCertemplate:joinBaseUrl('/education/train/mgt/deleteCertemplate'),
    queryCertemplate:joinBaseUrl('/education/train/mgt/queryCertemplate'),
    queryCertemplateList:joinBaseUrl('/education/train/mgt/queryCertemplateList'),
    updateCertemplate:joinBaseUrl('/education/train/mgt/updateCertemplate'),
    
    addCertificate:joinBaseUrl('/education/train/mgt/addCertificate'),
    deleteCertificate:joinBaseUrl('/education/train/mgt/deleteCertificate'),
    queryCertificate:joinBaseUrl('/education/train/mgt/queryCertificate'),
    updateCertificate:joinBaseUrl('/education/train/mgt/updateCertificate'),
    
    queryCertificateIssueList:joinBaseUrl('/education/train/mgt/queryCertificateIssueList'),
    addCertificateIssue:joinBaseUrl('/education/train/mgt/addCertificateIssue'),
    queryCertificateByCertIssueId:joinBaseUrl('/education/train/mgt/queryCertificateByCertIssueId'),
    EndTrain:joinBaseUrl('/education/train/mgt/EndTrain'),
    queryAvailableCourseList:joinBaseUrl('/education/course/emp/queryAvailableCourseList'),
    selectCourse:joinBaseUrl('/education/course/emp/selectCourse'),
    cancelCourse:joinBaseUrl('/education/course/emp/cancelCourse'),
    sendExamNotification:joinBaseUrl('/education/examination/mgt/sendExamNotification'),
    queryExamDetailByResId:joinBaseUrl('/education/examination/emp/queryExamDetailByResId'),
    sendCourseNotification:joinBaseUrl('/education/course/sendCourseNotification'),
  },
  examStu:{

    queryMyExaminationList:joinBaseUrl('/education/examination/emp/queryMyExaminationList'),
    startMyExamination:joinBaseUrl('/education/examination/emp/startMyExamination'),
    submitMyQuesAnswer:joinBaseUrl('/education/examination/emp/submitMyQuesAnswer'),
    completeExamination:joinBaseUrl('/education/examination/emp/completeExamination'),
    queryMyExaminationAnalysis:joinBaseUrl('/education/examination/emp/queryMyExaminationAnalysis'),
    applyMakeupExam:joinBaseUrl('/education/examination/emp/applyMakeupExam'),

    //公开考试
    pubstartMyExamination:joinBaseUrl('/pub/education/examination/emp/startMyExamination'),
    pubsubmitMyQuesAnswer:joinBaseUrl('/pub/education/examination/emp/submitMyQuesAnswer'),
    pubcompleteExamination:joinBaseUrl('/pub/education/examination/emp/completeExamination'),

    // 培训
    queryMyTrainList:joinBaseUrl('/education/train/emp/queryMyTrainList'),
    queryMyTrainDetails:joinBaseUrl('/education/train/emp/queryMyTrainDetails'),

    // 课程
    queryEmpCourseList:joinBaseUrl('/education/course/emp/queryEmpCourseList'),
    queryEmpCourseLessonList:joinBaseUrl('/education/course/emp/queryEmpCourseLessonList'),
    queryEmpCourseLessonDetails:joinBaseUrl('/education/course/emp/queryEmpCourseLessonDetails'),
    saveEmpCourseLessonProcess:joinBaseUrl('/education/course/emp/saveEmpCourseLessonProcess'),
    queryEmpCourseDetails:joinBaseUrl('/education/course/emp/queryEmpCourseDetails'),
    queryCourseDetails:joinBaseUrl('/education/course/queryCourseDetails'),
    addCourseSign:joinBaseUrl('/education/course/addCourseSign'),

    // 权限
    isEduMgt:joinBaseUrl('/education/role/isEduMgt'),

    // 签到
    queryCourseSignList:joinBaseUrl('/education/course/queryCourseSignList'),

    //证书
    queryCertificate:joinBaseUrl('/education/train/emp/queryCertificate'),
    // queryCertificateDetail:joinBaseUrl('/education/train/emp/queryCertificateDetail'),
    queryCertificateList:joinBaseUrl('/education/train/emp/queryCertificateList'),
  },
  ai:{
    queryProviderList: joinBaseUrl('/api/ai/providers/queryProviderList'),
    queryListModelList: joinBaseUrl('/api/ai/provider/model/lists/queryListModelList'),
    addModel: joinBaseUrl('/api/ai/models/addModel'),
    queryModelList: joinBaseUrl('/api/ai/models/queryModelList'),
    updateModel: joinBaseUrl('/api/ai/models/updateModel'),
    deleteModel: joinBaseUrl('/api/ai/models/deleteModel'),

    addAgent: joinBaseUrl('/api/ai/agents/addAgent'),
    queryAgentList: joinBaseUrl('/api/ai/agents/queryAgentList'),
    queryAgentListAll: joinBaseUrl('/api/ai/agents/queryAgentListAll'),
    deleteAgent: joinBaseUrl('/api/ai/agents/deleteAgent'),
    startOrStopStatus: joinBaseUrl('/api/ai/agents/startOrStopStatus'),
    queryAgent: joinBaseUrl('/api/ai/agents/queryAgent'),
    updateAgent: joinBaseUrl('/api/ai/agents/updateAgent'),

    chat: joinStreamUrl('/api/ai/chat'),
    audio2text:joinBaseUrl('/api/ai/audio2text'),
    queryConversationList: joinBaseUrl('/api/ai/conversations/queryConversationList'),
    addConversation: joinBaseUrl('/api/ai/conversations/addConversation'),
    queryChatList: joinBaseUrl('/api/ai/chats/queryChatList'),
    deleteConversation: joinBaseUrl('/api/ai/conversations/deleteConversation'),

    addInstruction: joinBaseUrl('/api/ai/agents/instructions/addInstruction'),
    deleteInstruction: joinBaseUrl('/api/ai/agents/instructions/deleteInstruction'),
    updateInstruction: joinBaseUrl('/api/ai/agents/instructions/updateInstruction'),
    queryInstructionList: joinBaseUrl('/api/ai/agents/instructions/queryInstructionList'),

    addDoc: joinBaseUrl('/api/ai/docs/addDoc'),
    deleteDoc: joinBaseUrl('/api/ai/docs/deleteDoc'),
    queryDocList: joinBaseUrl('/api/ai/docs/queryDocList'),

    models: joinBaseUrl('/api/ai/local/models'),

    addAIFlow:joinBaseUrl('/api/ai/flow/addAIFlow'),
    updateAIFlow:joinBaseUrl('/api/ai/flow/updateAIFlow'),
    deleteAIFlowById:joinBaseUrl('/api/ai/flow/deleteAIFlowById'),
    changeStatus:joinBaseUrl('/api/ai/flow/changeStatus'),
    queryAIFlowList:joinBaseUrl('/api/ai/flow/queryAIFlowList'),
    queryDefPageByCond:joinBaseUrl('/api/ai/flow/queryDefPageByCond'),
  },
  email:{
    addMailPlat: joinBaseUrl('/portal/mail/mailConfig/addMailPlat'),
    editMailPlat: joinBaseUrl('/portal/mail/mailConfig/editMailPlat'),
    delMailPlat: joinBaseUrl('/portal/mail/mailConfig/delMailPlat'),
    queryMailPlatList: joinBaseUrl('/portal/mail/mailConfig/queryMailPlatList'),
    
    queryEmpMailList: joinBaseUrl('/portal/mail/empMail/queryEmpMailList'),
    addEmpMail: joinBaseUrl('/portal/mail/empMail/addEmpMail'),
    delEmpMail: joinBaseUrl('/portal/mail/empMail/delEmpMail'),
    editEmpMail: joinBaseUrl('/portal/mail/empMail/editEmpMail'),
    saveMainEmpMail: joinBaseUrl('/portal/mail/empMail/saveMainEmpMail'),
    
    
    sendMail: joinBaseUrl('/portal/mail/mailManager/sendMail'),
    queryMailSendRecord: joinBaseUrl('/portal/mail/mailSendRecord/queryMailSendRecord'),
    getMail: joinBaseUrl('/portal/mail/mailManager/getMail'),
    queryEmpMailAddressBookList: joinBaseUrl('/portal/mail/empMailAddressBook/queryEmpMailAddressBookList'),
    addEmpMailAddressBook: joinBaseUrl('/portal/mail/empMailAddressBook/addEmpMailAddressBook'),
    editEmpMailAddressBook: joinBaseUrl('/portal/mail/empMailAddressBook/editEmpMailAddressBook'),
    delEmpMailAddressBook: joinBaseUrl('/portal/mail/empMailAddressBook/delEmpMailAddressBook'),
    getMailDetail: joinBaseUrl('/portal/mail/mailManager/getMailDetail'),
    delMail: joinBaseUrl('/portal/mail/mailManager/delMail'),
    getNoReadNum: joinBaseUrl('/portal/mail/mailManager/getNoReadNum'),
    saveDraft: joinBaseUrl('/portal/mail/mailManager/saveDraft'),
    flushMailList: joinBaseUrl('/portal/mail/mailManager/flushMailList'),
    flaggedOrNo: joinBaseUrl('/portal/mail/mailManager/flaggedOrNo'),
    batchFlag: joinBaseUrl('/portal/mail/mailManager/batchFlag'),

    addEmpMailSign: joinBaseUrl('/portal/mail/empMailSign/addEmpMailSign'),
    editEmpMailSign: joinBaseUrl('/portal/mail/empMailSign/editEmpMailSign'),
    delEmpMailSign: joinBaseUrl('/portal/mail/empMailSign/delEmpMailSign'),
    saveMainEmpMailSign: joinBaseUrl('/portal/mail/empMailSign/saveMainEmpMailSign'),
    queryEmpMailSignDtl: joinBaseUrl('/portal/mail/empMailSign/queryEmpMailSignDtl'),
    queryEmpMailSignList: joinBaseUrl('/portal/mail/empMailSign/queryEmpMailSignList'),
    sendReply: joinBaseUrl('/portal/mail/mailManager/sendReply'),
  },
  selfBuildApp:{
    //自建应用
    addSelfApp: joinBaseUrl('/develop/externalapp/selfapp/config/selfApp/addSelfApp'),
    editSelfApp: joinBaseUrl('/develop/externalapp/selfapp/config/selfApp/editSelfApp'),
    editSelfAppStatus: joinBaseUrl('/develop/externalapp/selfapp/config/selfApp/editSelfAppStatus'),
    delSelfApp: joinBaseUrl('/develop/externalapp/selfapp/config/selfApp/delSelfApp'),
    querySelfAppDtl: joinBaseUrl('/develop/externalapp/selfapp/config/selfApp/querySelfAppDtl'),
    querySelfAppList: joinBaseUrl('/develop/externalapp/selfapp/config/selfApp/querySelfAppList'),
    querySelfAppSecret: joinBaseUrl('/develop/externalapp/selfapp/config/selfApp/querySelfAppSecret'),

    //自建应用使用权限
    addSelfAppAuth: joinBaseUrl('/develop/externalapp/selfapp/config/selfAppAuth/addSelfAppAuth'),
    delSelfAppAuth: joinBaseUrl('/develop/externalapp/selfapp/config/selfAppAuth/delSelfAppAuth'),
    querySelfAppAuth: joinBaseUrl('/develop/externalapp/selfapp/config/selfAppAuth/querySelfAppAuth'),

    //自建应用用户授权
    setMySelfAppEmpAuth: joinBaseUrl('/develop/externalapp/selfapp/user/selfAppEmpAuth/setMySelfAppEmpAuth'),
    queryMySelfAppEmpAuth: joinBaseUrl('/develop/externalapp/selfapp/user/selfAppEmpAuth/queryMySelfAppEmpAuth'),
  },
  selfApp: { 
    //星标自建应用
    addStarSelfApp: joinBaseUrl('/develop/externalapp/selfapp/user/starSelfApp/addStarSelfApp'),
    delStarSelfApp: joinBaseUrl('/develop/externalapp/selfapp/user/starSelfApp/delStarSelfApp'),
    queryStarSelfAppList: joinBaseUrl('/develop/externalapp/selfapp/user/starSelfApp/queryStarSelfAppList'),
    adjustStarSelfAppSeq: joinBaseUrl('/develop/externalapp/selfapp/user/starSelfApp/adjustStarSelfAppSeq'),

    //获取我的自建应用
    querySelfAppList: joinBaseUrl('/develop/externalapp/selfapp/user/selfApp/querySelfAppList'),
    querySelfAppDtl: joinBaseUrl('/develop/externalapp/selfapp/user/selfApp/querySelfAppDtl'),
  },
  openapi: {
    getAuthorize: joinBaseUrl('/openapi/oauth2/getAuthorize'),
    // getAccessToken: joinBaseUrl('/openapi/oauth2/getAccessToken'),
    // getSign: joinBaseUrl('/openapi/oauth2/getSign'),
  },
  holidayMgt:{
    getOrgHolidayTpl:joinBaseUrl('/org/mgt/holidayMgt/getOrgHolidayTpl'),
    importOrgHolidayFromExcel:joinBaseUrl('/org/mgt/holidayMgt/importOrgHolidayFromExcel'),
    queryHolidayPageByCond:joinBaseUrl('/org/holiday/queryHolidayPageByCond'),
    queryHolidayByCond:joinBaseUrl('/org/holiday/queryHolidayByCond'),
    addHoliday:joinBaseUrl('/org/mgt/holidayMgt/addHoliday'),
    deleteById:joinBaseUrl('/org/mgt/holidayMgt/deleteById'),
    updateById:joinBaseUrl('/org/mgt/holidayMgt/updateById'),
    exportOrgHoliday:joinBaseUrl('/org/mgt/holidayMgt/exportOrgHoliday'),
    importSysHoliday:joinBaseUrl('/org/mgt/holidayMgt/importSysHoliday'),
  },
  holidays:{
    exportSysHoliday :joinBaseUrl('/sys/holiday/manager/exportSysHoliday'),
    getSysHolidayTpl :joinBaseUrl('/sys/holiday/manager/getSysHolidayTpl'),
    importSysHolidayFromExcel :joinBaseUrl('/sys/holiday/manager/importSysHolidayFromExcel'),
    queryHolidayPageByCond :joinBaseUrl('/sys/holiday/manager/queryHolidayPageByCond'),
    queryHolidayByCond :joinBaseUrl('/sys/holiday/manager/queryHolidayByCond'),
    addHoliday :joinBaseUrl('/sys/holiday/manager/addHoliday'),
    deleteById :joinBaseUrl('/sys/holiday/manager/deleteById'),
    updateById :joinBaseUrl('/sys/holiday/manager/updateById'),
  },
  communitySections:{
    addSections:joinBaseUrl('/org/mgt/communitySections/addSections'),
    updateSections:joinBaseUrl('/org/mgt/communitySections/updateSections'),
    deleteSections:joinBaseUrl('/org/mgt/communitySections/deleteSections'),
    updatePost:joinBaseUrl('/org/mgt/communityPost/updatePost'),
    updateComment:joinBaseUrl('/org/mgt/communityComment/updateComment'),
    queryPostPageList:joinBaseUrl('/org/mgt/communityPost/queryPostPageList'),
  },
  community:{
    querySectionsByCond:joinBaseUrl('/portal/community/section/querySectionsByCond'),
    addComment:joinBaseUrl('/portal/community/comment/addComment'),
    deleteComment:joinBaseUrl('/portal/community/comment/deleteComment'),
    likeCommunityComment:joinBaseUrl('/portal/community/comment/likeCommunityComment'),
    unlikeCommunityComment:joinBaseUrl('/portal/community/comment/unlikeCommunityComment'),
    topCommunityComment:joinBaseUrl('/portal/community/comment/topCommunityComment'),
    unTopCommunityComment:joinBaseUrl('/portal/community/comment/unTopCommunityComment'),
    queryCommunityCommentPage:joinBaseUrl('/portal/community/comment/queryCommunityCommentPage'),
    addCommunityPost:joinBaseUrl('/portal/community/post/addCommunityPost'),
    updateCommunityPost:joinBaseUrl('/portal/community/post/updateCommunityPost'),
    deleteCommunityPost:joinBaseUrl('/portal/community/post/deleteCommunityPost'),
    secretCommunityPost:joinBaseUrl('/portal/community/post/secretCommunityPost'),
    publicCommunityPost:joinBaseUrl('/portal/community/post/publicCommunityPost'),
    likeCommunityPost:joinBaseUrl('/portal/community/post/likeCommunityPost'),
    unLikeCommunityPost:joinBaseUrl('/portal/community/post/unLikeCommunityPost'),
    collectCommunityPost:joinBaseUrl('/portal/community/post/collectCommunityPost'),
    unCollectCommunityPost:joinBaseUrl('/portal/community/post/unCollectCommunityPost'),
    viewPost:joinBaseUrl('/portal/community/post/viewPost'),
    queryPostPageList:joinBaseUrl('/portal/community/post/queryPostPageList'),
    queryPersonalPostPageList:joinBaseUrl('/portal/community/post/queryPersonalPostPageList'),
    queryPersonalLikePostPageList:joinBaseUrl('/portal/community/post/queryPersonalLikePostPageList'),
    queryPersonalCollectPostPageList:joinBaseUrl('/portal/community/post/queryPersonalCollectPostPageList'),
    queryPersonalCollectSectionPageList:joinBaseUrl('/portal/community/section/queryPersonalCollectSectionPageList'),
    collectCommunitySection:joinBaseUrl('/portal/community/section/collectCommunitySection'),
    unCollectCommunitySection:joinBaseUrl('/portal/community/section/unCollectCommunitySection'),
    queryPostDetail:joinBaseUrl('/portal/community/post/queryPostDetail'),

  },
  push:{
    single:joinBaseUrl('/push/offline'),
  }
}
//注册组件
const install = function (Vue) {
  Vue.config.globalProperties.$api = api;
};


export default { install ,api }